/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DotDotDotDotPagesWebformIndexRouteImport } from './../pages/webform/index'
import { Route as DotDotDotDotPagesResetPasswordIndexRouteImport } from './../pages/reset-password/index'
import { Route as DotDotDotDotPagesCustomerzoneIndexRouteImport } from './../pages/customerzone/index'
import { Route as DotDotDotDotPagesActivateIndexRouteImport } from './../pages/activate/index'
import { Route as DotDotDotDotPagesVerifyRouteImport } from './../pages/verify'
import { Route as DotDotDotDotPagesSignUpIcpRouteImport } from './../pages/sign-up-icp'
import { Route as loginRouteImport } from './routes/login'
import { Route as DotDotDotDotPagesDebitOrderRouteImport } from './../pages/debit-order'
import { Route as DotDotDotDotPagesCompleteSignupRouteImport } from './../pages/complete-signup'
import { Route as DotDotDotDotPagesCompleteInviteRouteImport } from './../pages/complete-invite'
import { Route as authenticatedRouteImport } from './routes/_authenticated'
import { Route as DotDotDotDotPagesFeedbearIndexRouteImport } from './../pages/feedbear/index'
import { Route as DotDotDotDotPagesAppointmentIndexRouteImport } from './../pages/appointment/index'
import { Route as DotDotDotDotPagesIndexRouteImport } from './../pages/index'
import { Route as DotDotDotDotPagesTenantzoneSignatureRouteImport } from './../pages/tenantzone/signature'
import { Route as DotDotDotDotPagesIChar91tokenChar93RouteImport } from './../pages/i/[token]'
import { Route as DotDotDotDotPagesCustomerzoneViewquoteRouteImport } from './../pages/customerzone/viewquote'
import { Route as DotDotDotDotPagesCustomerzoneViewjobRouteImport } from './../pages/customerzone/viewjob'
import { Route as DotDotDotDotPagesCustomerzoneViewinvoiceRouteImport } from './../pages/customerzone/viewinvoice'
import { Route as DotDotDotDotPagesCustomerzoneViewappointmentRouteImport } from './../pages/customerzone/viewappointment'
import { Route as DotDotDotDotPagesCustomerzoneSignatureRouteImport } from './../pages/customerzone/signature'
import { Route as DotDotDotDotPagesCustomerzoneSageinvoicelistRouteImport } from './../pages/customerzone/sageinvoicelist'
import { Route as DotDotDotDotPagesCustomerzoneQuotelistRouteImport } from './../pages/customerzone/quotelist'
import { Route as DotDotDotDotPagesCustomerzoneJoblistRouteImport } from './../pages/customerzone/joblist'
import { Route as DotDotDotDotPagesCustomerzoneJobfeedbackRouteImport } from './../pages/customerzone/jobfeedback'
import { Route as DotDotDotDotPagesCustomerzoneInvoicelistRouteImport } from './../pages/customerzone/invoicelist'
import { Route as DotDotDotDotPagesCustomerzoneAppointmentlistRouteImport } from './../pages/customerzone/appointmentlist'
import { Route as DotDotDotDotPagesAdminRouteImport } from './../pages/admin'
import { Route as DotDotDotDotPagesVanChar91idChar93IndexRouteImport } from './../pages/van/[id]/index'
import { Route as DotDotDotDotPagesStockTakeChar91idChar93IndexRouteImport } from './../pages/stock-take/[id]/index'
import { Route as DotDotDotDotPagesVanListRouteImport } from './../pages/van/list'
import { Route as DotDotDotDotPagesVanCreateRouteImport } from './../pages/van/create'
import { Route as DotDotDotDotPagesSupplierListRouteImport } from './../pages/supplier/list'
import { Route as DotDotDotDotPagesSupplierCreateRouteImport } from './../pages/supplier/create'
import { Route as DotDotDotDotPagesSupplierChar91idChar93RouteImport } from './../pages/supplier/[id]'
import { Route as DotDotDotDotPagesStocktransactionListRouteImport } from './../pages/stocktransaction/list'
import { Route as DotDotDotDotPagesStocktransactionCreateRouteImport } from './../pages/stocktransaction/create'
import { Route as DotDotDotDotPagesStocktransactionChar91idChar93RouteImport } from './../pages/stocktransaction/[id]'
import { Route as DotDotDotDotPagesStockTakeListRouteImport } from './../pages/stock-take/list'
import { Route as DotDotDotDotPagesStockTakeCreateRouteImport } from './../pages/stock-take/create'
import { Route as DotDotDotDotPagesSettingsRoleSettingsRouteImport } from './../pages/settings/role-settings'
import { Route as DotDotDotDotPagesSettingsJobStatusRouteImport } from './../pages/settings/job-status'
import { Route as DotDotDotDotPagesSettingsChangePasswordRouteImport } from './../pages/settings/change-password'
import { Route as DotDotDotDotPagesReportListRouteImport } from './../pages/report/list'
import { Route as DotDotDotDotPagesQuoteListRouteImport } from './../pages/quote/list'
import { Route as DotDotDotDotPagesQuoteCreateRouteImport } from './../pages/quote/create'
import { Route as DotDotDotDotPagesQuoteChar91idChar93RouteImport } from './../pages/quote/[id]'
import { Route as DotDotDotDotPagesQueryListRouteImport } from './../pages/query/list'
import { Route as DotDotDotDotPagesQueryCreateRouteImport } from './../pages/query/create'
import { Route as DotDotDotDotPagesQueryChar91idChar93RouteImport } from './../pages/query/[id]'
import { Route as DotDotDotDotPagesPurchaseListRouteImport } from './../pages/purchase/list'
import { Route as DotDotDotDotPagesPurchaseCreateRouteImport } from './../pages/purchase/create'
import { Route as DotDotDotDotPagesPurchaseChar91idChar93RouteImport } from './../pages/purchase/[id]'
import { Route as DotDotDotDotPagesProjectListRouteImport } from './../pages/project/list'
import { Route as DotDotDotDotPagesProjectCreateRouteImport } from './../pages/project/create'
import { Route as DotDotDotDotPagesProjectChar91idChar93RouteImport } from './../pages/project/[id]'
import { Route as DotDotDotDotPagesNewCommunicationChar91idChar93RouteImport } from './../pages/new-communication/[id]'
import { Route as DotDotDotDotPagesMessageListRouteImport } from './../pages/message/list'
import { Route as DotDotDotDotPagesJobListRouteImport } from './../pages/job/list'
import { Route as DotDotDotDotPagesJobJobMapRouteImport } from './../pages/job/job-map'
import { Route as DotDotDotDotPagesJobCreateRouteImport } from './../pages/job/create'
import { Route as DotDotDotDotPagesJobChar91idChar93RouteImport } from './../pages/job/[id]'
import { Route as DotDotDotDotPagesJobScheduleListRouteImport } from './../pages/job-schedule/list'
import { Route as DotDotDotDotPagesJobScheduleCreateRouteImport } from './../pages/job-schedule/create'
import { Route as DotDotDotDotPagesJobScheduleChar91idChar93RouteImport } from './../pages/job-schedule/[id]'
import { Route as DotDotDotDotPagesInvoiceListRouteImport } from './../pages/invoice/list'
import { Route as DotDotDotDotPagesInvoiceCreateRouteImport } from './../pages/invoice/create'
import { Route as DotDotDotDotPagesInvoiceChar91idChar93RouteImport } from './../pages/invoice/[id]'
import { Route as DotDotDotDotPagesInventoryListRouteImport } from './../pages/inventory/list'
import { Route as DotDotDotDotPagesInventoryCreateRouteImport } from './../pages/inventory/create'
import { Route as DotDotDotDotPagesInventoryChar91idChar93RouteImport } from './../pages/inventory/[id]'
import { Route as DotDotDotDotPagesInventorySubcategoryListRouteImport } from './../pages/inventory-subcategory/list'
import { Route as DotDotDotDotPagesInventorySubcategoryCreateRouteImport } from './../pages/inventory-subcategory/create'
import { Route as DotDotDotDotPagesInventorySubcategoryChar91idChar93RouteImport } from './../pages/inventory-subcategory/[id]'
import { Route as DotDotDotDotPagesInventoryCategoryListRouteImport } from './../pages/inventory-category/list'
import { Route as DotDotDotDotPagesInventoryCategoryCreateRouteImport } from './../pages/inventory-category/create'
import { Route as DotDotDotDotPagesInventoryCategoryChar91idChar93RouteImport } from './../pages/inventory-category/[id]'
import { Route as DotDotDotDotPagesCustomerListRouteImport } from './../pages/customer/list'
import { Route as DotDotDotDotPagesCustomerCreateRouteImport } from './../pages/customer/create'
import { Route as DotDotDotDotPagesCustomerChar91idChar93RouteImport } from './../pages/customer/[id]'
import { Route as DotDotDotDotPagesBundleCreateRouteImport } from './../pages/bundle/create'
import { Route as DotDotDotDotPagesBundleChar91idChar93RouteImport } from './../pages/bundle/[id]'
import { Route as DotDotDotDotPagesAttachmentListRouteImport } from './../pages/attachment/list'
import { Route as DotDotDotDotPagesAssetListRouteImport } from './../pages/asset/list'
import { Route as DotDotDotDotPagesAssetCreateRouteImport } from './../pages/asset/create'
import { Route as DotDotDotDotPagesAssetChar91idChar93RouteImport } from './../pages/asset/[id]'
import { Route as DotDotDotDotPagesAppointmentSchedulerRouteImport } from './../pages/appointment/scheduler'
import { Route as appointmentListRedirectRouteImport } from './routes/appointment-list-redirect'
import { Route as DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRouteImport } from './../pages/webform/[origin]/[key]/[api]/index'
import { Route as DotDotDotDotPagesVanChar91idChar93EditRouteImport } from './../pages/van/[id]/edit'
import { Route as DotDotDotDotPagesStocktransactionTransferListRouteImport } from './../pages/stocktransaction/transfer/list'
import { Route as DotDotDotDotPagesStocktransactionGrvListRouteImport } from './../pages/stocktransaction/grv/list'
import { Route as DotDotDotDotPagesStocktransactionExternalTransferListRouteImport } from './../pages/stocktransaction/external-transfer/list'
import { Route as DotDotDotDotPagesStocktransactionAdjustmentListRouteImport } from './../pages/stocktransaction/adjustment/list'
import { Route as DotDotDotDotPagesStockTakeTemplateCreateRouteImport } from './../pages/stock-take/template/create'
import { Route as DotDotDotDotPagesStockTakeTemplateChar91idChar93RouteImport } from './../pages/stock-take/template/[id]'
import { Route as DotDotDotDotPagesStockTakeChar91idChar93EditRouteImport } from './../pages/stock-take/[id]/edit'
import { Route as DotDotDotDotPagesStockTakeChar91idChar93CopyRouteImport } from './../pages/stock-take/[id]/copy'
import { Route as DotDotDotDotPagesSettingsWebformListRouteImport } from './../pages/settings/webform/list'
import { Route as DotDotDotDotPagesSettingsWebformCreateRouteImport } from './../pages/settings/webform/create'
import { Route as DotDotDotDotPagesSettingsWebformChar91idChar93RouteImport } from './../pages/settings/webform/[id]'
import { Route as DotDotDotDotPagesSettingsWarehouseListRouteImport } from './../pages/settings/warehouse/list'
import { Route as DotDotDotDotPagesSettingsWarehouseCreateRouteImport } from './../pages/settings/warehouse/create'
import { Route as DotDotDotDotPagesSettingsWarehouseChar91idChar93RouteImport } from './../pages/settings/warehouse/[id]'
import { Route as DotDotDotDotPagesSettingsTriggerListRouteImport } from './../pages/settings/trigger/list'
import { Route as DotDotDotDotPagesSettingsTriggerCreateRouteImport } from './../pages/settings/trigger/create'
import { Route as DotDotDotDotPagesSettingsTriggerChar91idChar93RouteImport } from './../pages/settings/trigger/[id]'
import { Route as DotDotDotDotPagesSettingsTemplateListRouteImport } from './../pages/settings/template/list'
import { Route as DotDotDotDotPagesSettingsTemplateEditRouteImport } from './../pages/settings/template/edit'
import { Route as DotDotDotDotPagesSettingsTemplateCreateRouteImport } from './../pages/settings/template/create'
import { Route as DotDotDotDotPagesSettingsTemplateChar91idChar93RouteImport } from './../pages/settings/template/[id]'
import { Route as DotDotDotDotPagesSettingsTaskListRouteImport } from './../pages/settings/task/list'
import { Route as DotDotDotDotPagesSettingsTaskCreateRouteImport } from './../pages/settings/task/create'
import { Route as DotDotDotDotPagesSettingsTaskChar91idChar93RouteImport } from './../pages/settings/task/[id]'
import { Route as DotDotDotDotPagesSettingsSubscriptionSuccessRouteImport } from './../pages/settings/subscription/success'
import { Route as DotDotDotDotPagesSettingsSubscriptionPeachRouteImport } from './../pages/settings/subscription/peach'
import { Route as DotDotDotDotPagesSettingsSubscriptionManageRouteImport } from './../pages/settings/subscription/manage'
import { Route as DotDotDotDotPagesSettingsSubscriptionCancelRouteImport } from './../pages/settings/subscription/cancel'
import { Route as DotDotDotDotPagesSettingsStoreListRouteImport } from './../pages/settings/store/list'
import { Route as DotDotDotDotPagesSettingsStoreCreateRouteImport } from './../pages/settings/store/create'
import { Route as DotDotDotDotPagesSettingsStoreChar91idChar93RouteImport } from './../pages/settings/store/[id]'
import { Route as DotDotDotDotPagesSettingsSignaturetemplateListRouteImport } from './../pages/settings/signaturetemplate/list'
import { Route as DotDotDotDotPagesSettingsSignaturetemplateCreateRouteImport } from './../pages/settings/signaturetemplate/create'
import { Route as DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93RouteImport } from './../pages/settings/signaturetemplate/[id]'
import { Route as DotDotDotDotPagesSettingsQuoteManageRouteImport } from './../pages/settings/quote/manage'
import { Route as DotDotDotDotPagesSettingsQueryManageRouteImport } from './../pages/settings/query/manage'
import { Route as DotDotDotDotPagesSettingsPurchaseManageRouteImport } from './../pages/settings/purchase/manage'
import { Route as DotDotDotDotPagesSettingsProjectManageRouteImport } from './../pages/settings/project/manage'
import { Route as DotDotDotDotPagesSettingsPaymentPayfastRouteImport } from './../pages/settings/payment/payfast'
import { Route as DotDotDotDotPagesSettingsOptionListRouteImport } from './../pages/settings/option/list'
import { Route as DotDotDotDotPagesSettingsOptionCreateRouteImport } from './../pages/settings/option/create'
import { Route as DotDotDotDotPagesSettingsOptionChar91idChar93RouteImport } from './../pages/settings/option/[id]'
import { Route as DotDotDotDotPagesSettingsJobManageRouteImport } from './../pages/settings/job/manage'
import { Route as DotDotDotDotPagesSettingsInvoiceManageRouteImport } from './../pages/settings/invoice/manage'
import { Route as DotDotDotDotPagesSettingsInventoryManageRouteImport } from './../pages/settings/inventory/manage'
import { Route as DotDotDotDotPagesSettingsIntegrationOauthxeroRouteImport } from './../pages/settings/integration/oauthxero'
import { Route as DotDotDotDotPagesSettingsIntegrationOauthsageoneRouteImport } from './../pages/settings/integration/oauthsageone'
import { Route as DotDotDotDotPagesSettingsIntegrationOauthqboRouteImport } from './../pages/settings/integration/oauthqbo'
import { Route as DotDotDotDotPagesSettingsIntegrationManageRouteImport } from './../pages/settings/integration/manage'
import { Route as DotDotDotDotPagesSettingsImportSmartImportRouteImport } from './../pages/settings/import/smart-import'
import { Route as DotDotDotDotPagesSettingsImportListRouteImport } from './../pages/settings/import/list'
import { Route as DotDotDotDotPagesSettingsImportCreateRouteImport } from './../pages/settings/import/create'
import { Route as DotDotDotDotPagesSettingsFormListRouteImport } from './../pages/settings/form/list'
import { Route as DotDotDotDotPagesSettingsFormCreateRouteImport } from './../pages/settings/form/create'
import { Route as DotDotDotDotPagesSettingsFormChar91idChar93RouteImport } from './../pages/settings/form/[id]'
import { Route as DotDotDotDotPagesSettingsEmployeeListRouteImport } from './../pages/settings/employee/list'
import { Route as DotDotDotDotPagesSettingsEmployeeCreateRouteImport } from './../pages/settings/employee/create'
import { Route as DotDotDotDotPagesSettingsEmployeeChar91idChar93RouteImport } from './../pages/settings/employee/[id]'
import { Route as DotDotDotDotPagesSettingsDocumentManageRouteImport } from './../pages/settings/document/manage'
import { Route as DotDotDotDotPagesSettingsCustomerManageRouteImport } from './../pages/settings/customer/manage'
import { Route as DotDotDotDotPagesSettingsCompanyManageRouteImport } from './../pages/settings/company/manage'
import { Route as DotDotDotDotPagesSettingsAssetManageRouteImport } from './../pages/settings/asset/manage'
import { Route as DotDotDotDotPagesSettingsApiManageRouteImport } from './../pages/settings/api/manage'
import { Route as DotDotDotDotPagesQuoteViewChar91idChar93RouteImport } from './../pages/quote/view/[id]'
import { Route as DotDotDotDotPagesMessageBulkCreateRouteImport } from './../pages/message/bulk/create'
import { Route as DotDotDotDotPagesMessageBulkChar91idChar93RouteImport } from './../pages/message/bulk/[id]'
import { Route as DotDotDotDotPagesInvoiceViewChar91idChar93RouteImport } from './../pages/invoice/view/[id]'
import { Route as DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRouteImport } from './../pages/webform/[origin]/[key]/[api]/[css]/index'

const DotDotDotDotPagesWebformIndexRoute =
  DotDotDotDotPagesWebformIndexRouteImport.update({
    id: '/webform',
    path: '/webform',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesResetPasswordIndexRoute =
  DotDotDotDotPagesResetPasswordIndexRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneIndexRoute =
  DotDotDotDotPagesCustomerzoneIndexRouteImport.update({
    id: '/customerzone',
    path: '/customerzone',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesActivateIndexRoute =
  DotDotDotDotPagesActivateIndexRouteImport.update({
    id: '/activate',
    path: '/activate',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesVerifyRoute = DotDotDotDotPagesVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const DotDotDotDotPagesSignUpIcpRoute =
  DotDotDotDotPagesSignUpIcpRouteImport.update({
    id: '/sign-up-icp',
    path: '/sign-up-icp',
    getParentRoute: () => rootRouteImport,
  } as any)
const loginRoute = loginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DotDotDotDotPagesDebitOrderRoute =
  DotDotDotDotPagesDebitOrderRouteImport.update({
    id: '/debit-order',
    path: '/debit-order',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCompleteSignupRoute =
  DotDotDotDotPagesCompleteSignupRouteImport.update({
    id: '/complete-signup',
    path: '/complete-signup',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCompleteInviteRoute =
  DotDotDotDotPagesCompleteInviteRouteImport.update({
    id: '/complete-invite',
    path: '/complete-invite',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticatedRoute = authenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const DotDotDotDotPagesFeedbearIndexRoute =
  DotDotDotDotPagesFeedbearIndexRouteImport.update({
    id: '/feedbear',
    path: '/feedbear',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAppointmentIndexRoute =
  DotDotDotDotPagesAppointmentIndexRouteImport.update({
    id: '/appointment',
    path: '/appointment',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesIndexRoute = DotDotDotDotPagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authenticatedRoute,
} as any)
const DotDotDotDotPagesTenantzoneSignatureRoute =
  DotDotDotDotPagesTenantzoneSignatureRouteImport.update({
    id: '/tenantzone/signature',
    path: '/tenantzone/signature',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesIChar91tokenChar93Route =
  DotDotDotDotPagesIChar91tokenChar93RouteImport.update({
    id: '/i/$token',
    path: '/i/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneViewquoteRoute =
  DotDotDotDotPagesCustomerzoneViewquoteRouteImport.update({
    id: '/customerzone/viewquote',
    path: '/customerzone/viewquote',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneViewjobRoute =
  DotDotDotDotPagesCustomerzoneViewjobRouteImport.update({
    id: '/customerzone/viewjob',
    path: '/customerzone/viewjob',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneViewinvoiceRoute =
  DotDotDotDotPagesCustomerzoneViewinvoiceRouteImport.update({
    id: '/customerzone/viewinvoice',
    path: '/customerzone/viewinvoice',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneViewappointmentRoute =
  DotDotDotDotPagesCustomerzoneViewappointmentRouteImport.update({
    id: '/customerzone/viewappointment',
    path: '/customerzone/viewappointment',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneSignatureRoute =
  DotDotDotDotPagesCustomerzoneSignatureRouteImport.update({
    id: '/customerzone/signature',
    path: '/customerzone/signature',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneSageinvoicelistRoute =
  DotDotDotDotPagesCustomerzoneSageinvoicelistRouteImport.update({
    id: '/customerzone/sageinvoicelist',
    path: '/customerzone/sageinvoicelist',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneQuotelistRoute =
  DotDotDotDotPagesCustomerzoneQuotelistRouteImport.update({
    id: '/customerzone/quotelist',
    path: '/customerzone/quotelist',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneJoblistRoute =
  DotDotDotDotPagesCustomerzoneJoblistRouteImport.update({
    id: '/customerzone/joblist',
    path: '/customerzone/joblist',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneJobfeedbackRoute =
  DotDotDotDotPagesCustomerzoneJobfeedbackRouteImport.update({
    id: '/customerzone/jobfeedback',
    path: '/customerzone/jobfeedback',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneInvoicelistRoute =
  DotDotDotDotPagesCustomerzoneInvoicelistRouteImport.update({
    id: '/customerzone/invoicelist',
    path: '/customerzone/invoicelist',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesCustomerzoneAppointmentlistRoute =
  DotDotDotDotPagesCustomerzoneAppointmentlistRouteImport.update({
    id: '/customerzone/appointmentlist',
    path: '/customerzone/appointmentlist',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotDotDotDotPagesAdminRoute = DotDotDotDotPagesAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => authenticatedRoute,
} as any)
const DotDotDotDotPagesVanChar91idChar93IndexRoute =
  DotDotDotDotPagesVanChar91idChar93IndexRouteImport.update({
    id: '/van/$id',
    path: '/van/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeChar91idChar93IndexRoute =
  DotDotDotDotPagesStockTakeChar91idChar93IndexRouteImport.update({
    id: '/stock-take/$id',
    path: '/stock-take/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesVanListRoute =
  DotDotDotDotPagesVanListRouteImport.update({
    id: '/van/list',
    path: '/van/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesVanCreateRoute =
  DotDotDotDotPagesVanCreateRouteImport.update({
    id: '/van/create',
    path: '/van/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSupplierListRoute =
  DotDotDotDotPagesSupplierListRouteImport.update({
    id: '/supplier/list',
    path: '/supplier/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSupplierCreateRoute =
  DotDotDotDotPagesSupplierCreateRouteImport.update({
    id: '/supplier/create',
    path: '/supplier/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSupplierChar91idChar93Route =
  DotDotDotDotPagesSupplierChar91idChar93RouteImport.update({
    id: '/supplier/$id',
    path: '/supplier/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionListRoute =
  DotDotDotDotPagesStocktransactionListRouteImport.update({
    id: '/stocktransaction/list',
    path: '/stocktransaction/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionCreateRoute =
  DotDotDotDotPagesStocktransactionCreateRouteImport.update({
    id: '/stocktransaction/create',
    path: '/stocktransaction/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionChar91idChar93Route =
  DotDotDotDotPagesStocktransactionChar91idChar93RouteImport.update({
    id: '/stocktransaction/$id',
    path: '/stocktransaction/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeListRoute =
  DotDotDotDotPagesStockTakeListRouteImport.update({
    id: '/stock-take/list',
    path: '/stock-take/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeCreateRoute =
  DotDotDotDotPagesStockTakeCreateRouteImport.update({
    id: '/stock-take/create',
    path: '/stock-take/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsRoleSettingsRoute =
  DotDotDotDotPagesSettingsRoleSettingsRouteImport.update({
    id: '/settings/role-settings',
    path: '/settings/role-settings',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsJobStatusRoute =
  DotDotDotDotPagesSettingsJobStatusRouteImport.update({
    id: '/settings/job-status',
    path: '/settings/job-status',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsChangePasswordRoute =
  DotDotDotDotPagesSettingsChangePasswordRouteImport.update({
    id: '/settings/change-password',
    path: '/settings/change-password',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesReportListRoute =
  DotDotDotDotPagesReportListRouteImport.update({
    id: '/report/list',
    path: '/report/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQuoteListRoute =
  DotDotDotDotPagesQuoteListRouteImport.update({
    id: '/quote/list',
    path: '/quote/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQuoteCreateRoute =
  DotDotDotDotPagesQuoteCreateRouteImport.update({
    id: '/quote/create',
    path: '/quote/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQuoteChar91idChar93Route =
  DotDotDotDotPagesQuoteChar91idChar93RouteImport.update({
    id: '/quote/$id',
    path: '/quote/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQueryListRoute =
  DotDotDotDotPagesQueryListRouteImport.update({
    id: '/query/list',
    path: '/query/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQueryCreateRoute =
  DotDotDotDotPagesQueryCreateRouteImport.update({
    id: '/query/create',
    path: '/query/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQueryChar91idChar93Route =
  DotDotDotDotPagesQueryChar91idChar93RouteImport.update({
    id: '/query/$id',
    path: '/query/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesPurchaseListRoute =
  DotDotDotDotPagesPurchaseListRouteImport.update({
    id: '/purchase/list',
    path: '/purchase/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesPurchaseCreateRoute =
  DotDotDotDotPagesPurchaseCreateRouteImport.update({
    id: '/purchase/create',
    path: '/purchase/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesPurchaseChar91idChar93Route =
  DotDotDotDotPagesPurchaseChar91idChar93RouteImport.update({
    id: '/purchase/$id',
    path: '/purchase/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesProjectListRoute =
  DotDotDotDotPagesProjectListRouteImport.update({
    id: '/project/list',
    path: '/project/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesProjectCreateRoute =
  DotDotDotDotPagesProjectCreateRouteImport.update({
    id: '/project/create',
    path: '/project/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesProjectChar91idChar93Route =
  DotDotDotDotPagesProjectChar91idChar93RouteImport.update({
    id: '/project/$id',
    path: '/project/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesNewCommunicationChar91idChar93Route =
  DotDotDotDotPagesNewCommunicationChar91idChar93RouteImport.update({
    id: '/new-communication/$id',
    path: '/new-communication/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesMessageListRoute =
  DotDotDotDotPagesMessageListRouteImport.update({
    id: '/message/list',
    path: '/message/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobListRoute =
  DotDotDotDotPagesJobListRouteImport.update({
    id: '/job/list',
    path: '/job/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobJobMapRoute =
  DotDotDotDotPagesJobJobMapRouteImport.update({
    id: '/job/job-map',
    path: '/job/job-map',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobCreateRoute =
  DotDotDotDotPagesJobCreateRouteImport.update({
    id: '/job/create',
    path: '/job/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobChar91idChar93Route =
  DotDotDotDotPagesJobChar91idChar93RouteImport.update({
    id: '/job/$id',
    path: '/job/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobScheduleListRoute =
  DotDotDotDotPagesJobScheduleListRouteImport.update({
    id: '/job-schedule/list',
    path: '/job-schedule/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobScheduleCreateRoute =
  DotDotDotDotPagesJobScheduleCreateRouteImport.update({
    id: '/job-schedule/create',
    path: '/job-schedule/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesJobScheduleChar91idChar93Route =
  DotDotDotDotPagesJobScheduleChar91idChar93RouteImport.update({
    id: '/job-schedule/$id',
    path: '/job-schedule/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInvoiceListRoute =
  DotDotDotDotPagesInvoiceListRouteImport.update({
    id: '/invoice/list',
    path: '/invoice/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInvoiceCreateRoute =
  DotDotDotDotPagesInvoiceCreateRouteImport.update({
    id: '/invoice/create',
    path: '/invoice/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInvoiceChar91idChar93Route =
  DotDotDotDotPagesInvoiceChar91idChar93RouteImport.update({
    id: '/invoice/$id',
    path: '/invoice/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryListRoute =
  DotDotDotDotPagesInventoryListRouteImport.update({
    id: '/inventory/list',
    path: '/inventory/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryCreateRoute =
  DotDotDotDotPagesInventoryCreateRouteImport.update({
    id: '/inventory/create',
    path: '/inventory/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryChar91idChar93Route =
  DotDotDotDotPagesInventoryChar91idChar93RouteImport.update({
    id: '/inventory/$id',
    path: '/inventory/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventorySubcategoryListRoute =
  DotDotDotDotPagesInventorySubcategoryListRouteImport.update({
    id: '/inventory-subcategory/list',
    path: '/inventory-subcategory/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventorySubcategoryCreateRoute =
  DotDotDotDotPagesInventorySubcategoryCreateRouteImport.update({
    id: '/inventory-subcategory/create',
    path: '/inventory-subcategory/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventorySubcategoryChar91idChar93Route =
  DotDotDotDotPagesInventorySubcategoryChar91idChar93RouteImport.update({
    id: '/inventory-subcategory/$id',
    path: '/inventory-subcategory/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryCategoryListRoute =
  DotDotDotDotPagesInventoryCategoryListRouteImport.update({
    id: '/inventory-category/list',
    path: '/inventory-category/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryCategoryCreateRoute =
  DotDotDotDotPagesInventoryCategoryCreateRouteImport.update({
    id: '/inventory-category/create',
    path: '/inventory-category/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInventoryCategoryChar91idChar93Route =
  DotDotDotDotPagesInventoryCategoryChar91idChar93RouteImport.update({
    id: '/inventory-category/$id',
    path: '/inventory-category/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesCustomerListRoute =
  DotDotDotDotPagesCustomerListRouteImport.update({
    id: '/customer/list',
    path: '/customer/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesCustomerCreateRoute =
  DotDotDotDotPagesCustomerCreateRouteImport.update({
    id: '/customer/create',
    path: '/customer/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesCustomerChar91idChar93Route =
  DotDotDotDotPagesCustomerChar91idChar93RouteImport.update({
    id: '/customer/$id',
    path: '/customer/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesBundleCreateRoute =
  DotDotDotDotPagesBundleCreateRouteImport.update({
    id: '/bundle/create',
    path: '/bundle/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesBundleChar91idChar93Route =
  DotDotDotDotPagesBundleChar91idChar93RouteImport.update({
    id: '/bundle/$id',
    path: '/bundle/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAttachmentListRoute =
  DotDotDotDotPagesAttachmentListRouteImport.update({
    id: '/attachment/list',
    path: '/attachment/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAssetListRoute =
  DotDotDotDotPagesAssetListRouteImport.update({
    id: '/asset/list',
    path: '/asset/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAssetCreateRoute =
  DotDotDotDotPagesAssetCreateRouteImport.update({
    id: '/asset/create',
    path: '/asset/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAssetChar91idChar93Route =
  DotDotDotDotPagesAssetChar91idChar93RouteImport.update({
    id: '/asset/$id',
    path: '/asset/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesAppointmentSchedulerRoute =
  DotDotDotDotPagesAppointmentSchedulerRouteImport.update({
    id: '/appointment/scheduler',
    path: '/appointment/scheduler',
    getParentRoute: () => authenticatedRoute,
  } as any)
const appointmentListRedirectRoute = appointmentListRedirectRouteImport.update({
  id: '/appointment/list',
  path: '/appointment/list',
  getParentRoute: () => authenticatedRoute,
} as any)
const DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute =
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRouteImport.update(
    {
      id: '/webform/$origin/$key/$api',
      path: '/webform/$origin/$key/$api',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const DotDotDotDotPagesVanChar91idChar93EditRoute =
  DotDotDotDotPagesVanChar91idChar93EditRouteImport.update({
    id: '/van/$id/edit',
    path: '/van/$id/edit',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionTransferListRoute =
  DotDotDotDotPagesStocktransactionTransferListRouteImport.update({
    id: '/stocktransaction/transfer/list',
    path: '/stocktransaction/transfer/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionGrvListRoute =
  DotDotDotDotPagesStocktransactionGrvListRouteImport.update({
    id: '/stocktransaction/grv/list',
    path: '/stocktransaction/grv/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionExternalTransferListRoute =
  DotDotDotDotPagesStocktransactionExternalTransferListRouteImport.update({
    id: '/stocktransaction/external-transfer/list',
    path: '/stocktransaction/external-transfer/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStocktransactionAdjustmentListRoute =
  DotDotDotDotPagesStocktransactionAdjustmentListRouteImport.update({
    id: '/stocktransaction/adjustment/list',
    path: '/stocktransaction/adjustment/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeTemplateCreateRoute =
  DotDotDotDotPagesStockTakeTemplateCreateRouteImport.update({
    id: '/stock-take/template/create',
    path: '/stock-take/template/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeTemplateChar91idChar93Route =
  DotDotDotDotPagesStockTakeTemplateChar91idChar93RouteImport.update({
    id: '/stock-take/template/$id',
    path: '/stock-take/template/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeChar91idChar93EditRoute =
  DotDotDotDotPagesStockTakeChar91idChar93EditRouteImport.update({
    id: '/stock-take/$id/edit',
    path: '/stock-take/$id/edit',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesStockTakeChar91idChar93CopyRoute =
  DotDotDotDotPagesStockTakeChar91idChar93CopyRouteImport.update({
    id: '/stock-take/$id/copy',
    path: '/stock-take/$id/copy',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWebformListRoute =
  DotDotDotDotPagesSettingsWebformListRouteImport.update({
    id: '/settings/webform/list',
    path: '/settings/webform/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWebformCreateRoute =
  DotDotDotDotPagesSettingsWebformCreateRouteImport.update({
    id: '/settings/webform/create',
    path: '/settings/webform/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWebformChar91idChar93Route =
  DotDotDotDotPagesSettingsWebformChar91idChar93RouteImport.update({
    id: '/settings/webform/$id',
    path: '/settings/webform/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWarehouseListRoute =
  DotDotDotDotPagesSettingsWarehouseListRouteImport.update({
    id: '/settings/warehouse/list',
    path: '/settings/warehouse/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWarehouseCreateRoute =
  DotDotDotDotPagesSettingsWarehouseCreateRouteImport.update({
    id: '/settings/warehouse/create',
    path: '/settings/warehouse/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsWarehouseChar91idChar93Route =
  DotDotDotDotPagesSettingsWarehouseChar91idChar93RouteImport.update({
    id: '/settings/warehouse/$id',
    path: '/settings/warehouse/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTriggerListRoute =
  DotDotDotDotPagesSettingsTriggerListRouteImport.update({
    id: '/settings/trigger/list',
    path: '/settings/trigger/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTriggerCreateRoute =
  DotDotDotDotPagesSettingsTriggerCreateRouteImport.update({
    id: '/settings/trigger/create',
    path: '/settings/trigger/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTriggerChar91idChar93Route =
  DotDotDotDotPagesSettingsTriggerChar91idChar93RouteImport.update({
    id: '/settings/trigger/$id',
    path: '/settings/trigger/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTemplateListRoute =
  DotDotDotDotPagesSettingsTemplateListRouteImport.update({
    id: '/settings/template/list',
    path: '/settings/template/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTemplateEditRoute =
  DotDotDotDotPagesSettingsTemplateEditRouteImport.update({
    id: '/settings/template/edit',
    path: '/settings/template/edit',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTemplateCreateRoute =
  DotDotDotDotPagesSettingsTemplateCreateRouteImport.update({
    id: '/settings/template/create',
    path: '/settings/template/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTemplateChar91idChar93Route =
  DotDotDotDotPagesSettingsTemplateChar91idChar93RouteImport.update({
    id: '/settings/template/$id',
    path: '/settings/template/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTaskListRoute =
  DotDotDotDotPagesSettingsTaskListRouteImport.update({
    id: '/settings/task/list',
    path: '/settings/task/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTaskCreateRoute =
  DotDotDotDotPagesSettingsTaskCreateRouteImport.update({
    id: '/settings/task/create',
    path: '/settings/task/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsTaskChar91idChar93Route =
  DotDotDotDotPagesSettingsTaskChar91idChar93RouteImport.update({
    id: '/settings/task/$id',
    path: '/settings/task/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSubscriptionSuccessRoute =
  DotDotDotDotPagesSettingsSubscriptionSuccessRouteImport.update({
    id: '/settings/subscription/success',
    path: '/settings/subscription/success',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSubscriptionPeachRoute =
  DotDotDotDotPagesSettingsSubscriptionPeachRouteImport.update({
    id: '/settings/subscription/peach',
    path: '/settings/subscription/peach',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSubscriptionManageRoute =
  DotDotDotDotPagesSettingsSubscriptionManageRouteImport.update({
    id: '/settings/subscription/manage',
    path: '/settings/subscription/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSubscriptionCancelRoute =
  DotDotDotDotPagesSettingsSubscriptionCancelRouteImport.update({
    id: '/settings/subscription/cancel',
    path: '/settings/subscription/cancel',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsStoreListRoute =
  DotDotDotDotPagesSettingsStoreListRouteImport.update({
    id: '/settings/store/list',
    path: '/settings/store/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsStoreCreateRoute =
  DotDotDotDotPagesSettingsStoreCreateRouteImport.update({
    id: '/settings/store/create',
    path: '/settings/store/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsStoreChar91idChar93Route =
  DotDotDotDotPagesSettingsStoreChar91idChar93RouteImport.update({
    id: '/settings/store/$id',
    path: '/settings/store/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSignaturetemplateListRoute =
  DotDotDotDotPagesSettingsSignaturetemplateListRouteImport.update({
    id: '/settings/signaturetemplate/list',
    path: '/settings/signaturetemplate/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSignaturetemplateCreateRoute =
  DotDotDotDotPagesSettingsSignaturetemplateCreateRouteImport.update({
    id: '/settings/signaturetemplate/create',
    path: '/settings/signaturetemplate/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route =
  DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93RouteImport.update({
    id: '/settings/signaturetemplate/$id',
    path: '/settings/signaturetemplate/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsQuoteManageRoute =
  DotDotDotDotPagesSettingsQuoteManageRouteImport.update({
    id: '/settings/quote/manage',
    path: '/settings/quote/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsQueryManageRoute =
  DotDotDotDotPagesSettingsQueryManageRouteImport.update({
    id: '/settings/query/manage',
    path: '/settings/query/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsPurchaseManageRoute =
  DotDotDotDotPagesSettingsPurchaseManageRouteImport.update({
    id: '/settings/purchase/manage',
    path: '/settings/purchase/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsProjectManageRoute =
  DotDotDotDotPagesSettingsProjectManageRouteImport.update({
    id: '/settings/project/manage',
    path: '/settings/project/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsPaymentPayfastRoute =
  DotDotDotDotPagesSettingsPaymentPayfastRouteImport.update({
    id: '/settings/payment/payfast',
    path: '/settings/payment/payfast',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsOptionListRoute =
  DotDotDotDotPagesSettingsOptionListRouteImport.update({
    id: '/settings/option/list',
    path: '/settings/option/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsOptionCreateRoute =
  DotDotDotDotPagesSettingsOptionCreateRouteImport.update({
    id: '/settings/option/create',
    path: '/settings/option/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsOptionChar91idChar93Route =
  DotDotDotDotPagesSettingsOptionChar91idChar93RouteImport.update({
    id: '/settings/option/$id',
    path: '/settings/option/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsJobManageRoute =
  DotDotDotDotPagesSettingsJobManageRouteImport.update({
    id: '/settings/job/manage',
    path: '/settings/job/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsInvoiceManageRoute =
  DotDotDotDotPagesSettingsInvoiceManageRouteImport.update({
    id: '/settings/invoice/manage',
    path: '/settings/invoice/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsInventoryManageRoute =
  DotDotDotDotPagesSettingsInventoryManageRouteImport.update({
    id: '/settings/inventory/manage',
    path: '/settings/inventory/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsIntegrationOauthxeroRoute =
  DotDotDotDotPagesSettingsIntegrationOauthxeroRouteImport.update({
    id: '/settings/integration/oauthxero',
    path: '/settings/integration/oauthxero',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute =
  DotDotDotDotPagesSettingsIntegrationOauthsageoneRouteImport.update({
    id: '/settings/integration/oauthsageone',
    path: '/settings/integration/oauthsageone',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsIntegrationOauthqboRoute =
  DotDotDotDotPagesSettingsIntegrationOauthqboRouteImport.update({
    id: '/settings/integration/oauthqbo',
    path: '/settings/integration/oauthqbo',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsIntegrationManageRoute =
  DotDotDotDotPagesSettingsIntegrationManageRouteImport.update({
    id: '/settings/integration/manage',
    path: '/settings/integration/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsImportSmartImportRoute =
  DotDotDotDotPagesSettingsImportSmartImportRouteImport.update({
    id: '/settings/import/smart',
    path: '/settings/import/smart',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsImportListRoute =
  DotDotDotDotPagesSettingsImportListRouteImport.update({
    id: '/settings/import/list',
    path: '/settings/import/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsImportCreateRoute =
  DotDotDotDotPagesSettingsImportCreateRouteImport.update({
    id: '/settings/import/create',
    path: '/settings/import/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsFormListRoute =
  DotDotDotDotPagesSettingsFormListRouteImport.update({
    id: '/settings/form/list',
    path: '/settings/form/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsFormCreateRoute =
  DotDotDotDotPagesSettingsFormCreateRouteImport.update({
    id: '/settings/form/create',
    path: '/settings/form/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsFormChar91idChar93Route =
  DotDotDotDotPagesSettingsFormChar91idChar93RouteImport.update({
    id: '/settings/form/$id',
    path: '/settings/form/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsEmployeeListRoute =
  DotDotDotDotPagesSettingsEmployeeListRouteImport.update({
    id: '/settings/employee/list',
    path: '/settings/employee/list',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsEmployeeCreateRoute =
  DotDotDotDotPagesSettingsEmployeeCreateRouteImport.update({
    id: '/settings/employee/create',
    path: '/settings/employee/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsEmployeeChar91idChar93Route =
  DotDotDotDotPagesSettingsEmployeeChar91idChar93RouteImport.update({
    id: '/settings/employee/$id',
    path: '/settings/employee/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsDocumentManageRoute =
  DotDotDotDotPagesSettingsDocumentManageRouteImport.update({
    id: '/settings/document/manage',
    path: '/settings/document/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsCustomerManageRoute =
  DotDotDotDotPagesSettingsCustomerManageRouteImport.update({
    id: '/settings/customer/manage',
    path: '/settings/customer/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsCompanyManageRoute =
  DotDotDotDotPagesSettingsCompanyManageRouteImport.update({
    id: '/settings/company/manage',
    path: '/settings/company/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsAssetManageRoute =
  DotDotDotDotPagesSettingsAssetManageRouteImport.update({
    id: '/settings/asset/manage',
    path: '/settings/asset/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesSettingsApiManageRoute =
  DotDotDotDotPagesSettingsApiManageRouteImport.update({
    id: '/settings/api/manage',
    path: '/settings/api/manage',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesQuoteViewChar91idChar93Route =
  DotDotDotDotPagesQuoteViewChar91idChar93RouteImport.update({
    id: '/quote/view/$id',
    path: '/quote/view/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesMessageBulkCreateRoute =
  DotDotDotDotPagesMessageBulkCreateRouteImport.update({
    id: '/message/bulk/create',
    path: '/message/bulk/create',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesMessageBulkChar91idChar93Route =
  DotDotDotDotPagesMessageBulkChar91idChar93RouteImport.update({
    id: '/message/bulk/$id',
    path: '/message/bulk/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesInvoiceViewChar91idChar93Route =
  DotDotDotDotPagesInvoiceViewChar91idChar93RouteImport.update({
    id: '/invoice/view/$id',
    path: '/invoice/view/$id',
    getParentRoute: () => authenticatedRoute,
  } as any)
const DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute =
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRouteImport.update(
    {
      id: '/webform/$origin/$key/$api/$css',
      path: '/webform/$origin/$key/$api/$css',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof DotDotDotDotPagesIndexRoute
  '/complete-invite': typeof DotDotDotDotPagesCompleteInviteRoute
  '/complete-signup': typeof DotDotDotDotPagesCompleteSignupRoute
  '/debit-order': typeof DotDotDotDotPagesDebitOrderRoute
  '/login': typeof loginRoute
  '/sign-up-icp': typeof DotDotDotDotPagesSignUpIcpRoute
  '/verify': typeof DotDotDotDotPagesVerifyRoute
  '/activate': typeof DotDotDotDotPagesActivateIndexRoute
  '/customerzone': typeof DotDotDotDotPagesCustomerzoneIndexRoute
  '/reset-password': typeof DotDotDotDotPagesResetPasswordIndexRoute
  '/webform': typeof DotDotDotDotPagesWebformIndexRoute
  '/admin': typeof DotDotDotDotPagesAdminRoute
  '/customerzone/appointmentlist': typeof DotDotDotDotPagesCustomerzoneAppointmentlistRoute
  '/customerzone/invoicelist': typeof DotDotDotDotPagesCustomerzoneInvoicelistRoute
  '/customerzone/jobfeedback': typeof DotDotDotDotPagesCustomerzoneJobfeedbackRoute
  '/customerzone/joblist': typeof DotDotDotDotPagesCustomerzoneJoblistRoute
  '/customerzone/quotelist': typeof DotDotDotDotPagesCustomerzoneQuotelistRoute
  '/customerzone/sageinvoicelist': typeof DotDotDotDotPagesCustomerzoneSageinvoicelistRoute
  '/customerzone/signature': typeof DotDotDotDotPagesCustomerzoneSignatureRoute
  '/customerzone/viewappointment': typeof DotDotDotDotPagesCustomerzoneViewappointmentRoute
  '/customerzone/viewinvoice': typeof DotDotDotDotPagesCustomerzoneViewinvoiceRoute
  '/customerzone/viewjob': typeof DotDotDotDotPagesCustomerzoneViewjobRoute
  '/customerzone/viewquote': typeof DotDotDotDotPagesCustomerzoneViewquoteRoute
  '/i/$token': typeof DotDotDotDotPagesIChar91tokenChar93Route
  '/tenantzone/signature': typeof DotDotDotDotPagesTenantzoneSignatureRoute
  '/appointment': typeof DotDotDotDotPagesAppointmentIndexRoute
  '/feedbear': typeof DotDotDotDotPagesFeedbearIndexRoute
  '/appointment/list': typeof appointmentListRedirectRoute
  '/appointment/scheduler': typeof DotDotDotDotPagesAppointmentSchedulerRoute
  '/asset/$id': typeof DotDotDotDotPagesAssetChar91idChar93Route
  '/asset/create': typeof DotDotDotDotPagesAssetCreateRoute
  '/asset/list': typeof DotDotDotDotPagesAssetListRoute
  '/attachment/list': typeof DotDotDotDotPagesAttachmentListRoute
  '/bundle/$id': typeof DotDotDotDotPagesBundleChar91idChar93Route
  '/bundle/create': typeof DotDotDotDotPagesBundleCreateRoute
  '/customer/$id': typeof DotDotDotDotPagesCustomerChar91idChar93Route
  '/customer/create': typeof DotDotDotDotPagesCustomerCreateRoute
  '/customer/list': typeof DotDotDotDotPagesCustomerListRoute
  '/inventory-category/$id': typeof DotDotDotDotPagesInventoryCategoryChar91idChar93Route
  '/inventory-category/create': typeof DotDotDotDotPagesInventoryCategoryCreateRoute
  '/inventory-category/list': typeof DotDotDotDotPagesInventoryCategoryListRoute
  '/inventory-subcategory/$id': typeof DotDotDotDotPagesInventorySubcategoryChar91idChar93Route
  '/inventory-subcategory/create': typeof DotDotDotDotPagesInventorySubcategoryCreateRoute
  '/inventory-subcategory/list': typeof DotDotDotDotPagesInventorySubcategoryListRoute
  '/inventory/$id': typeof DotDotDotDotPagesInventoryChar91idChar93Route
  '/inventory/create': typeof DotDotDotDotPagesInventoryCreateRoute
  '/inventory/list': typeof DotDotDotDotPagesInventoryListRoute
  '/invoice/$id': typeof DotDotDotDotPagesInvoiceChar91idChar93Route
  '/invoice/create': typeof DotDotDotDotPagesInvoiceCreateRoute
  '/invoice/list': typeof DotDotDotDotPagesInvoiceListRoute
  '/job-schedule/$id': typeof DotDotDotDotPagesJobScheduleChar91idChar93Route
  '/job-schedule/create': typeof DotDotDotDotPagesJobScheduleCreateRoute
  '/job-schedule/list': typeof DotDotDotDotPagesJobScheduleListRoute
  '/job/$id': typeof DotDotDotDotPagesJobChar91idChar93Route
  '/job/create': typeof DotDotDotDotPagesJobCreateRoute
  '/job/job-map': typeof DotDotDotDotPagesJobJobMapRoute
  '/job/list': typeof DotDotDotDotPagesJobListRoute
  '/message/list': typeof DotDotDotDotPagesMessageListRoute
  '/new-communication/$id': typeof DotDotDotDotPagesNewCommunicationChar91idChar93Route
  '/project/$id': typeof DotDotDotDotPagesProjectChar91idChar93Route
  '/project/create': typeof DotDotDotDotPagesProjectCreateRoute
  '/project/list': typeof DotDotDotDotPagesProjectListRoute
  '/purchase/$id': typeof DotDotDotDotPagesPurchaseChar91idChar93Route
  '/purchase/create': typeof DotDotDotDotPagesPurchaseCreateRoute
  '/purchase/list': typeof DotDotDotDotPagesPurchaseListRoute
  '/query/$id': typeof DotDotDotDotPagesQueryChar91idChar93Route
  '/query/create': typeof DotDotDotDotPagesQueryCreateRoute
  '/query/list': typeof DotDotDotDotPagesQueryListRoute
  '/quote/$id': typeof DotDotDotDotPagesQuoteChar91idChar93Route
  '/quote/create': typeof DotDotDotDotPagesQuoteCreateRoute
  '/quote/list': typeof DotDotDotDotPagesQuoteListRoute
  '/report/list': typeof DotDotDotDotPagesReportListRoute
  '/settings/change-password': typeof DotDotDotDotPagesSettingsChangePasswordRoute
  '/settings/job-status': typeof DotDotDotDotPagesSettingsJobStatusRoute
  '/settings/role-settings': typeof DotDotDotDotPagesSettingsRoleSettingsRoute
  '/stock-take/create': typeof DotDotDotDotPagesStockTakeCreateRoute
  '/stock-take/list': typeof DotDotDotDotPagesStockTakeListRoute
  '/stocktransaction/$id': typeof DotDotDotDotPagesStocktransactionChar91idChar93Route
  '/stocktransaction/create': typeof DotDotDotDotPagesStocktransactionCreateRoute
  '/stocktransaction/list': typeof DotDotDotDotPagesStocktransactionListRoute
  '/supplier/$id': typeof DotDotDotDotPagesSupplierChar91idChar93Route
  '/supplier/create': typeof DotDotDotDotPagesSupplierCreateRoute
  '/supplier/list': typeof DotDotDotDotPagesSupplierListRoute
  '/van/create': typeof DotDotDotDotPagesVanCreateRoute
  '/van/list': typeof DotDotDotDotPagesVanListRoute
  '/stock-take/$id': typeof DotDotDotDotPagesStockTakeChar91idChar93IndexRoute
  '/van/$id': typeof DotDotDotDotPagesVanChar91idChar93IndexRoute
  '/invoice/view/$id': typeof DotDotDotDotPagesInvoiceViewChar91idChar93Route
  '/message/bulk/$id': typeof DotDotDotDotPagesMessageBulkChar91idChar93Route
  '/message/bulk/create': typeof DotDotDotDotPagesMessageBulkCreateRoute
  '/quote/view/$id': typeof DotDotDotDotPagesQuoteViewChar91idChar93Route
  '/settings/api/manage': typeof DotDotDotDotPagesSettingsApiManageRoute
  '/settings/asset/manage': typeof DotDotDotDotPagesSettingsAssetManageRoute
  '/settings/company/manage': typeof DotDotDotDotPagesSettingsCompanyManageRoute
  '/settings/customer/manage': typeof DotDotDotDotPagesSettingsCustomerManageRoute
  '/settings/document/manage': typeof DotDotDotDotPagesSettingsDocumentManageRoute
  '/settings/employee/$id': typeof DotDotDotDotPagesSettingsEmployeeChar91idChar93Route
  '/settings/employee/create': typeof DotDotDotDotPagesSettingsEmployeeCreateRoute
  '/settings/employee/list': typeof DotDotDotDotPagesSettingsEmployeeListRoute
  '/settings/form/$id': typeof DotDotDotDotPagesSettingsFormChar91idChar93Route
  '/settings/form/create': typeof DotDotDotDotPagesSettingsFormCreateRoute
  '/settings/form/list': typeof DotDotDotDotPagesSettingsFormListRoute
  '/settings/import/create': typeof DotDotDotDotPagesSettingsImportCreateRoute
  '/settings/import/list': typeof DotDotDotDotPagesSettingsImportListRoute
  '/settings/import/smart': typeof DotDotDotDotPagesSettingsImportSmartImportRoute
  '/settings/integration/manage': typeof DotDotDotDotPagesSettingsIntegrationManageRoute
  '/settings/integration/oauthqbo': typeof DotDotDotDotPagesSettingsIntegrationOauthqboRoute
  '/settings/integration/oauthsageone': typeof DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute
  '/settings/integration/oauthxero': typeof DotDotDotDotPagesSettingsIntegrationOauthxeroRoute
  '/settings/inventory/manage': typeof DotDotDotDotPagesSettingsInventoryManageRoute
  '/settings/invoice/manage': typeof DotDotDotDotPagesSettingsInvoiceManageRoute
  '/settings/job/manage': typeof DotDotDotDotPagesSettingsJobManageRoute
  '/settings/option/$id': typeof DotDotDotDotPagesSettingsOptionChar91idChar93Route
  '/settings/option/create': typeof DotDotDotDotPagesSettingsOptionCreateRoute
  '/settings/option/list': typeof DotDotDotDotPagesSettingsOptionListRoute
  '/settings/payment/payfast': typeof DotDotDotDotPagesSettingsPaymentPayfastRoute
  '/settings/project/manage': typeof DotDotDotDotPagesSettingsProjectManageRoute
  '/settings/purchase/manage': typeof DotDotDotDotPagesSettingsPurchaseManageRoute
  '/settings/query/manage': typeof DotDotDotDotPagesSettingsQueryManageRoute
  '/settings/quote/manage': typeof DotDotDotDotPagesSettingsQuoteManageRoute
  '/settings/signaturetemplate/$id': typeof DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route
  '/settings/signaturetemplate/create': typeof DotDotDotDotPagesSettingsSignaturetemplateCreateRoute
  '/settings/signaturetemplate/list': typeof DotDotDotDotPagesSettingsSignaturetemplateListRoute
  '/settings/store/$id': typeof DotDotDotDotPagesSettingsStoreChar91idChar93Route
  '/settings/store/create': typeof DotDotDotDotPagesSettingsStoreCreateRoute
  '/settings/store/list': typeof DotDotDotDotPagesSettingsStoreListRoute
  '/settings/subscription/cancel': typeof DotDotDotDotPagesSettingsSubscriptionCancelRoute
  '/settings/subscription/manage': typeof DotDotDotDotPagesSettingsSubscriptionManageRoute
  '/settings/subscription/peach': typeof DotDotDotDotPagesSettingsSubscriptionPeachRoute
  '/settings/subscription/success': typeof DotDotDotDotPagesSettingsSubscriptionSuccessRoute
  '/settings/task/$id': typeof DotDotDotDotPagesSettingsTaskChar91idChar93Route
  '/settings/task/create': typeof DotDotDotDotPagesSettingsTaskCreateRoute
  '/settings/task/list': typeof DotDotDotDotPagesSettingsTaskListRoute
  '/settings/template/$id': typeof DotDotDotDotPagesSettingsTemplateChar91idChar93Route
  '/settings/template/create': typeof DotDotDotDotPagesSettingsTemplateCreateRoute
  '/settings/template/edit': typeof DotDotDotDotPagesSettingsTemplateEditRoute
  '/settings/template/list': typeof DotDotDotDotPagesSettingsTemplateListRoute
  '/settings/trigger/$id': typeof DotDotDotDotPagesSettingsTriggerChar91idChar93Route
  '/settings/trigger/create': typeof DotDotDotDotPagesSettingsTriggerCreateRoute
  '/settings/trigger/list': typeof DotDotDotDotPagesSettingsTriggerListRoute
  '/settings/warehouse/$id': typeof DotDotDotDotPagesSettingsWarehouseChar91idChar93Route
  '/settings/warehouse/create': typeof DotDotDotDotPagesSettingsWarehouseCreateRoute
  '/settings/warehouse/list': typeof DotDotDotDotPagesSettingsWarehouseListRoute
  '/settings/webform/$id': typeof DotDotDotDotPagesSettingsWebformChar91idChar93Route
  '/settings/webform/create': typeof DotDotDotDotPagesSettingsWebformCreateRoute
  '/settings/webform/list': typeof DotDotDotDotPagesSettingsWebformListRoute
  '/stock-take/$id/copy': typeof DotDotDotDotPagesStockTakeChar91idChar93CopyRoute
  '/stock-take/$id/edit': typeof DotDotDotDotPagesStockTakeChar91idChar93EditRoute
  '/stock-take/template/$id': typeof DotDotDotDotPagesStockTakeTemplateChar91idChar93Route
  '/stock-take/template/create': typeof DotDotDotDotPagesStockTakeTemplateCreateRoute
  '/stocktransaction/adjustment/list': typeof DotDotDotDotPagesStocktransactionAdjustmentListRoute
  '/stocktransaction/external-transfer/list': typeof DotDotDotDotPagesStocktransactionExternalTransferListRoute
  '/stocktransaction/grv/list': typeof DotDotDotDotPagesStocktransactionGrvListRoute
  '/stocktransaction/transfer/list': typeof DotDotDotDotPagesStocktransactionTransferListRoute
  '/van/$id/edit': typeof DotDotDotDotPagesVanChar91idChar93EditRoute
  '/webform/$origin/$key/$api': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute
  '/webform/$origin/$key/$api/$css': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute
}
export interface FileRoutesByTo {
  '/complete-invite': typeof DotDotDotDotPagesCompleteInviteRoute
  '/complete-signup': typeof DotDotDotDotPagesCompleteSignupRoute
  '/debit-order': typeof DotDotDotDotPagesDebitOrderRoute
  '/login': typeof loginRoute
  '/sign-up-icp': typeof DotDotDotDotPagesSignUpIcpRoute
  '/verify': typeof DotDotDotDotPagesVerifyRoute
  '/activate': typeof DotDotDotDotPagesActivateIndexRoute
  '/customerzone': typeof DotDotDotDotPagesCustomerzoneIndexRoute
  '/reset-password': typeof DotDotDotDotPagesResetPasswordIndexRoute
  '/webform': typeof DotDotDotDotPagesWebformIndexRoute
  '/admin': typeof DotDotDotDotPagesAdminRoute
  '/customerzone/appointmentlist': typeof DotDotDotDotPagesCustomerzoneAppointmentlistRoute
  '/customerzone/invoicelist': typeof DotDotDotDotPagesCustomerzoneInvoicelistRoute
  '/customerzone/jobfeedback': typeof DotDotDotDotPagesCustomerzoneJobfeedbackRoute
  '/customerzone/joblist': typeof DotDotDotDotPagesCustomerzoneJoblistRoute
  '/customerzone/quotelist': typeof DotDotDotDotPagesCustomerzoneQuotelistRoute
  '/customerzone/sageinvoicelist': typeof DotDotDotDotPagesCustomerzoneSageinvoicelistRoute
  '/customerzone/signature': typeof DotDotDotDotPagesCustomerzoneSignatureRoute
  '/customerzone/viewappointment': typeof DotDotDotDotPagesCustomerzoneViewappointmentRoute
  '/customerzone/viewinvoice': typeof DotDotDotDotPagesCustomerzoneViewinvoiceRoute
  '/customerzone/viewjob': typeof DotDotDotDotPagesCustomerzoneViewjobRoute
  '/customerzone/viewquote': typeof DotDotDotDotPagesCustomerzoneViewquoteRoute
  '/i/$token': typeof DotDotDotDotPagesIChar91tokenChar93Route
  '/tenantzone/signature': typeof DotDotDotDotPagesTenantzoneSignatureRoute
  '/': typeof DotDotDotDotPagesIndexRoute
  '/appointment': typeof DotDotDotDotPagesAppointmentIndexRoute
  '/feedbear': typeof DotDotDotDotPagesFeedbearIndexRoute
  '/appointment/list': typeof appointmentListRedirectRoute
  '/appointment/scheduler': typeof DotDotDotDotPagesAppointmentSchedulerRoute
  '/asset/$id': typeof DotDotDotDotPagesAssetChar91idChar93Route
  '/asset/create': typeof DotDotDotDotPagesAssetCreateRoute
  '/asset/list': typeof DotDotDotDotPagesAssetListRoute
  '/attachment/list': typeof DotDotDotDotPagesAttachmentListRoute
  '/bundle/$id': typeof DotDotDotDotPagesBundleChar91idChar93Route
  '/bundle/create': typeof DotDotDotDotPagesBundleCreateRoute
  '/customer/$id': typeof DotDotDotDotPagesCustomerChar91idChar93Route
  '/customer/create': typeof DotDotDotDotPagesCustomerCreateRoute
  '/customer/list': typeof DotDotDotDotPagesCustomerListRoute
  '/inventory-category/$id': typeof DotDotDotDotPagesInventoryCategoryChar91idChar93Route
  '/inventory-category/create': typeof DotDotDotDotPagesInventoryCategoryCreateRoute
  '/inventory-category/list': typeof DotDotDotDotPagesInventoryCategoryListRoute
  '/inventory-subcategory/$id': typeof DotDotDotDotPagesInventorySubcategoryChar91idChar93Route
  '/inventory-subcategory/create': typeof DotDotDotDotPagesInventorySubcategoryCreateRoute
  '/inventory-subcategory/list': typeof DotDotDotDotPagesInventorySubcategoryListRoute
  '/inventory/$id': typeof DotDotDotDotPagesInventoryChar91idChar93Route
  '/inventory/create': typeof DotDotDotDotPagesInventoryCreateRoute
  '/inventory/list': typeof DotDotDotDotPagesInventoryListRoute
  '/invoice/$id': typeof DotDotDotDotPagesInvoiceChar91idChar93Route
  '/invoice/create': typeof DotDotDotDotPagesInvoiceCreateRoute
  '/invoice/list': typeof DotDotDotDotPagesInvoiceListRoute
  '/job-schedule/$id': typeof DotDotDotDotPagesJobScheduleChar91idChar93Route
  '/job-schedule/create': typeof DotDotDotDotPagesJobScheduleCreateRoute
  '/job-schedule/list': typeof DotDotDotDotPagesJobScheduleListRoute
  '/job/$id': typeof DotDotDotDotPagesJobChar91idChar93Route
  '/job/create': typeof DotDotDotDotPagesJobCreateRoute
  '/job/job-map': typeof DotDotDotDotPagesJobJobMapRoute
  '/job/list': typeof DotDotDotDotPagesJobListRoute
  '/message/list': typeof DotDotDotDotPagesMessageListRoute
  '/new-communication/$id': typeof DotDotDotDotPagesNewCommunicationChar91idChar93Route
  '/project/$id': typeof DotDotDotDotPagesProjectChar91idChar93Route
  '/project/create': typeof DotDotDotDotPagesProjectCreateRoute
  '/project/list': typeof DotDotDotDotPagesProjectListRoute
  '/purchase/$id': typeof DotDotDotDotPagesPurchaseChar91idChar93Route
  '/purchase/create': typeof DotDotDotDotPagesPurchaseCreateRoute
  '/purchase/list': typeof DotDotDotDotPagesPurchaseListRoute
  '/query/$id': typeof DotDotDotDotPagesQueryChar91idChar93Route
  '/query/create': typeof DotDotDotDotPagesQueryCreateRoute
  '/query/list': typeof DotDotDotDotPagesQueryListRoute
  '/quote/$id': typeof DotDotDotDotPagesQuoteChar91idChar93Route
  '/quote/create': typeof DotDotDotDotPagesQuoteCreateRoute
  '/quote/list': typeof DotDotDotDotPagesQuoteListRoute
  '/report/list': typeof DotDotDotDotPagesReportListRoute
  '/settings/change-password': typeof DotDotDotDotPagesSettingsChangePasswordRoute
  '/settings/job-status': typeof DotDotDotDotPagesSettingsJobStatusRoute
  '/settings/role-settings': typeof DotDotDotDotPagesSettingsRoleSettingsRoute
  '/stock-take/create': typeof DotDotDotDotPagesStockTakeCreateRoute
  '/stock-take/list': typeof DotDotDotDotPagesStockTakeListRoute
  '/stocktransaction/$id': typeof DotDotDotDotPagesStocktransactionChar91idChar93Route
  '/stocktransaction/create': typeof DotDotDotDotPagesStocktransactionCreateRoute
  '/stocktransaction/list': typeof DotDotDotDotPagesStocktransactionListRoute
  '/supplier/$id': typeof DotDotDotDotPagesSupplierChar91idChar93Route
  '/supplier/create': typeof DotDotDotDotPagesSupplierCreateRoute
  '/supplier/list': typeof DotDotDotDotPagesSupplierListRoute
  '/van/create': typeof DotDotDotDotPagesVanCreateRoute
  '/van/list': typeof DotDotDotDotPagesVanListRoute
  '/stock-take/$id': typeof DotDotDotDotPagesStockTakeChar91idChar93IndexRoute
  '/van/$id': typeof DotDotDotDotPagesVanChar91idChar93IndexRoute
  '/invoice/view/$id': typeof DotDotDotDotPagesInvoiceViewChar91idChar93Route
  '/message/bulk/$id': typeof DotDotDotDotPagesMessageBulkChar91idChar93Route
  '/message/bulk/create': typeof DotDotDotDotPagesMessageBulkCreateRoute
  '/quote/view/$id': typeof DotDotDotDotPagesQuoteViewChar91idChar93Route
  '/settings/api/manage': typeof DotDotDotDotPagesSettingsApiManageRoute
  '/settings/asset/manage': typeof DotDotDotDotPagesSettingsAssetManageRoute
  '/settings/company/manage': typeof DotDotDotDotPagesSettingsCompanyManageRoute
  '/settings/customer/manage': typeof DotDotDotDotPagesSettingsCustomerManageRoute
  '/settings/document/manage': typeof DotDotDotDotPagesSettingsDocumentManageRoute
  '/settings/employee/$id': typeof DotDotDotDotPagesSettingsEmployeeChar91idChar93Route
  '/settings/employee/create': typeof DotDotDotDotPagesSettingsEmployeeCreateRoute
  '/settings/employee/list': typeof DotDotDotDotPagesSettingsEmployeeListRoute
  '/settings/form/$id': typeof DotDotDotDotPagesSettingsFormChar91idChar93Route
  '/settings/form/create': typeof DotDotDotDotPagesSettingsFormCreateRoute
  '/settings/form/list': typeof DotDotDotDotPagesSettingsFormListRoute
  '/settings/import/create': typeof DotDotDotDotPagesSettingsImportCreateRoute
  '/settings/import/list': typeof DotDotDotDotPagesSettingsImportListRoute
  '/settings/import/smart': typeof DotDotDotDotPagesSettingsImportSmartImportRoute
  '/settings/integration/manage': typeof DotDotDotDotPagesSettingsIntegrationManageRoute
  '/settings/integration/oauthqbo': typeof DotDotDotDotPagesSettingsIntegrationOauthqboRoute
  '/settings/integration/oauthsageone': typeof DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute
  '/settings/integration/oauthxero': typeof DotDotDotDotPagesSettingsIntegrationOauthxeroRoute
  '/settings/inventory/manage': typeof DotDotDotDotPagesSettingsInventoryManageRoute
  '/settings/invoice/manage': typeof DotDotDotDotPagesSettingsInvoiceManageRoute
  '/settings/job/manage': typeof DotDotDotDotPagesSettingsJobManageRoute
  '/settings/option/$id': typeof DotDotDotDotPagesSettingsOptionChar91idChar93Route
  '/settings/option/create': typeof DotDotDotDotPagesSettingsOptionCreateRoute
  '/settings/option/list': typeof DotDotDotDotPagesSettingsOptionListRoute
  '/settings/payment/payfast': typeof DotDotDotDotPagesSettingsPaymentPayfastRoute
  '/settings/project/manage': typeof DotDotDotDotPagesSettingsProjectManageRoute
  '/settings/purchase/manage': typeof DotDotDotDotPagesSettingsPurchaseManageRoute
  '/settings/query/manage': typeof DotDotDotDotPagesSettingsQueryManageRoute
  '/settings/quote/manage': typeof DotDotDotDotPagesSettingsQuoteManageRoute
  '/settings/signaturetemplate/$id': typeof DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route
  '/settings/signaturetemplate/create': typeof DotDotDotDotPagesSettingsSignaturetemplateCreateRoute
  '/settings/signaturetemplate/list': typeof DotDotDotDotPagesSettingsSignaturetemplateListRoute
  '/settings/store/$id': typeof DotDotDotDotPagesSettingsStoreChar91idChar93Route
  '/settings/store/create': typeof DotDotDotDotPagesSettingsStoreCreateRoute
  '/settings/store/list': typeof DotDotDotDotPagesSettingsStoreListRoute
  '/settings/subscription/cancel': typeof DotDotDotDotPagesSettingsSubscriptionCancelRoute
  '/settings/subscription/manage': typeof DotDotDotDotPagesSettingsSubscriptionManageRoute
  '/settings/subscription/peach': typeof DotDotDotDotPagesSettingsSubscriptionPeachRoute
  '/settings/subscription/success': typeof DotDotDotDotPagesSettingsSubscriptionSuccessRoute
  '/settings/task/$id': typeof DotDotDotDotPagesSettingsTaskChar91idChar93Route
  '/settings/task/create': typeof DotDotDotDotPagesSettingsTaskCreateRoute
  '/settings/task/list': typeof DotDotDotDotPagesSettingsTaskListRoute
  '/settings/template/$id': typeof DotDotDotDotPagesSettingsTemplateChar91idChar93Route
  '/settings/template/create': typeof DotDotDotDotPagesSettingsTemplateCreateRoute
  '/settings/template/edit': typeof DotDotDotDotPagesSettingsTemplateEditRoute
  '/settings/template/list': typeof DotDotDotDotPagesSettingsTemplateListRoute
  '/settings/trigger/$id': typeof DotDotDotDotPagesSettingsTriggerChar91idChar93Route
  '/settings/trigger/create': typeof DotDotDotDotPagesSettingsTriggerCreateRoute
  '/settings/trigger/list': typeof DotDotDotDotPagesSettingsTriggerListRoute
  '/settings/warehouse/$id': typeof DotDotDotDotPagesSettingsWarehouseChar91idChar93Route
  '/settings/warehouse/create': typeof DotDotDotDotPagesSettingsWarehouseCreateRoute
  '/settings/warehouse/list': typeof DotDotDotDotPagesSettingsWarehouseListRoute
  '/settings/webform/$id': typeof DotDotDotDotPagesSettingsWebformChar91idChar93Route
  '/settings/webform/create': typeof DotDotDotDotPagesSettingsWebformCreateRoute
  '/settings/webform/list': typeof DotDotDotDotPagesSettingsWebformListRoute
  '/stock-take/$id/copy': typeof DotDotDotDotPagesStockTakeChar91idChar93CopyRoute
  '/stock-take/$id/edit': typeof DotDotDotDotPagesStockTakeChar91idChar93EditRoute
  '/stock-take/template/$id': typeof DotDotDotDotPagesStockTakeTemplateChar91idChar93Route
  '/stock-take/template/create': typeof DotDotDotDotPagesStockTakeTemplateCreateRoute
  '/stocktransaction/adjustment/list': typeof DotDotDotDotPagesStocktransactionAdjustmentListRoute
  '/stocktransaction/external-transfer/list': typeof DotDotDotDotPagesStocktransactionExternalTransferListRoute
  '/stocktransaction/grv/list': typeof DotDotDotDotPagesStocktransactionGrvListRoute
  '/stocktransaction/transfer/list': typeof DotDotDotDotPagesStocktransactionTransferListRoute
  '/van/$id/edit': typeof DotDotDotDotPagesVanChar91idChar93EditRoute
  '/webform/$origin/$key/$api': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute
  '/webform/$origin/$key/$api/$css': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof authenticatedRouteWithChildren
  '/complete-invite': typeof DotDotDotDotPagesCompleteInviteRoute
  '/complete-signup': typeof DotDotDotDotPagesCompleteSignupRoute
  '/debit-order': typeof DotDotDotDotPagesDebitOrderRoute
  '/login': typeof loginRoute
  '/sign-up-icp': typeof DotDotDotDotPagesSignUpIcpRoute
  '/verify': typeof DotDotDotDotPagesVerifyRoute
  '/activate': typeof DotDotDotDotPagesActivateIndexRoute
  '/customerzone': typeof DotDotDotDotPagesCustomerzoneIndexRoute
  '/reset-password': typeof DotDotDotDotPagesResetPasswordIndexRoute
  '/webform': typeof DotDotDotDotPagesWebformIndexRoute
  '/_authenticated/admin': typeof DotDotDotDotPagesAdminRoute
  '/customerzone/appointmentlist': typeof DotDotDotDotPagesCustomerzoneAppointmentlistRoute
  '/customerzone/invoicelist': typeof DotDotDotDotPagesCustomerzoneInvoicelistRoute
  '/customerzone/jobfeedback': typeof DotDotDotDotPagesCustomerzoneJobfeedbackRoute
  '/customerzone/joblist': typeof DotDotDotDotPagesCustomerzoneJoblistRoute
  '/customerzone/quotelist': typeof DotDotDotDotPagesCustomerzoneQuotelistRoute
  '/customerzone/sageinvoicelist': typeof DotDotDotDotPagesCustomerzoneSageinvoicelistRoute
  '/customerzone/signature': typeof DotDotDotDotPagesCustomerzoneSignatureRoute
  '/customerzone/viewappointment': typeof DotDotDotDotPagesCustomerzoneViewappointmentRoute
  '/customerzone/viewinvoice': typeof DotDotDotDotPagesCustomerzoneViewinvoiceRoute
  '/customerzone/viewjob': typeof DotDotDotDotPagesCustomerzoneViewjobRoute
  '/customerzone/viewquote': typeof DotDotDotDotPagesCustomerzoneViewquoteRoute
  '/i/$token': typeof DotDotDotDotPagesIChar91tokenChar93Route
  '/tenantzone/signature': typeof DotDotDotDotPagesTenantzoneSignatureRoute
  '/_authenticated/': typeof DotDotDotDotPagesIndexRoute
  '/_authenticated/appointment': typeof DotDotDotDotPagesAppointmentIndexRoute
  '/_authenticated/feedbear': typeof DotDotDotDotPagesFeedbearIndexRoute
  '/_authenticated/appointment/list': typeof appointmentListRedirectRoute
  '/_authenticated/appointment/scheduler': typeof DotDotDotDotPagesAppointmentSchedulerRoute
  '/_authenticated/asset/$id': typeof DotDotDotDotPagesAssetChar91idChar93Route
  '/_authenticated/asset/create': typeof DotDotDotDotPagesAssetCreateRoute
  '/_authenticated/asset/list': typeof DotDotDotDotPagesAssetListRoute
  '/_authenticated/attachment/list': typeof DotDotDotDotPagesAttachmentListRoute
  '/_authenticated/bundle/$id': typeof DotDotDotDotPagesBundleChar91idChar93Route
  '/_authenticated/bundle/create': typeof DotDotDotDotPagesBundleCreateRoute
  '/_authenticated/customer/$id': typeof DotDotDotDotPagesCustomerChar91idChar93Route
  '/_authenticated/customer/create': typeof DotDotDotDotPagesCustomerCreateRoute
  '/_authenticated/customer/list': typeof DotDotDotDotPagesCustomerListRoute
  '/_authenticated/inventory-category/$id': typeof DotDotDotDotPagesInventoryCategoryChar91idChar93Route
  '/_authenticated/inventory-category/create': typeof DotDotDotDotPagesInventoryCategoryCreateRoute
  '/_authenticated/inventory-category/list': typeof DotDotDotDotPagesInventoryCategoryListRoute
  '/_authenticated/inventory-subcategory/$id': typeof DotDotDotDotPagesInventorySubcategoryChar91idChar93Route
  '/_authenticated/inventory-subcategory/create': typeof DotDotDotDotPagesInventorySubcategoryCreateRoute
  '/_authenticated/inventory-subcategory/list': typeof DotDotDotDotPagesInventorySubcategoryListRoute
  '/_authenticated/inventory/$id': typeof DotDotDotDotPagesInventoryChar91idChar93Route
  '/_authenticated/inventory/create': typeof DotDotDotDotPagesInventoryCreateRoute
  '/_authenticated/inventory/list': typeof DotDotDotDotPagesInventoryListRoute
  '/_authenticated/invoice/$id': typeof DotDotDotDotPagesInvoiceChar91idChar93Route
  '/_authenticated/invoice/create': typeof DotDotDotDotPagesInvoiceCreateRoute
  '/_authenticated/invoice/list': typeof DotDotDotDotPagesInvoiceListRoute
  '/_authenticated/job-schedule/$id': typeof DotDotDotDotPagesJobScheduleChar91idChar93Route
  '/_authenticated/job-schedule/create': typeof DotDotDotDotPagesJobScheduleCreateRoute
  '/_authenticated/job-schedule/list': typeof DotDotDotDotPagesJobScheduleListRoute
  '/_authenticated/job/$id': typeof DotDotDotDotPagesJobChar91idChar93Route
  '/_authenticated/job/create': typeof DotDotDotDotPagesJobCreateRoute
  '/_authenticated/job/job-map': typeof DotDotDotDotPagesJobJobMapRoute
  '/_authenticated/job/list': typeof DotDotDotDotPagesJobListRoute
  '/_authenticated/message/list': typeof DotDotDotDotPagesMessageListRoute
  '/_authenticated/new-communication/$id': typeof DotDotDotDotPagesNewCommunicationChar91idChar93Route
  '/_authenticated/project/$id': typeof DotDotDotDotPagesProjectChar91idChar93Route
  '/_authenticated/project/create': typeof DotDotDotDotPagesProjectCreateRoute
  '/_authenticated/project/list': typeof DotDotDotDotPagesProjectListRoute
  '/_authenticated/purchase/$id': typeof DotDotDotDotPagesPurchaseChar91idChar93Route
  '/_authenticated/purchase/create': typeof DotDotDotDotPagesPurchaseCreateRoute
  '/_authenticated/purchase/list': typeof DotDotDotDotPagesPurchaseListRoute
  '/_authenticated/query/$id': typeof DotDotDotDotPagesQueryChar91idChar93Route
  '/_authenticated/query/create': typeof DotDotDotDotPagesQueryCreateRoute
  '/_authenticated/query/list': typeof DotDotDotDotPagesQueryListRoute
  '/_authenticated/quote/$id': typeof DotDotDotDotPagesQuoteChar91idChar93Route
  '/_authenticated/quote/create': typeof DotDotDotDotPagesQuoteCreateRoute
  '/_authenticated/quote/list': typeof DotDotDotDotPagesQuoteListRoute
  '/_authenticated/report/list': typeof DotDotDotDotPagesReportListRoute
  '/_authenticated/settings/change-password': typeof DotDotDotDotPagesSettingsChangePasswordRoute
  '/_authenticated/settings/job-status': typeof DotDotDotDotPagesSettingsJobStatusRoute
  '/_authenticated/settings/role-settings': typeof DotDotDotDotPagesSettingsRoleSettingsRoute
  '/_authenticated/stock-take/create': typeof DotDotDotDotPagesStockTakeCreateRoute
  '/_authenticated/stock-take/list': typeof DotDotDotDotPagesStockTakeListRoute
  '/_authenticated/stocktransaction/$id': typeof DotDotDotDotPagesStocktransactionChar91idChar93Route
  '/_authenticated/stocktransaction/create': typeof DotDotDotDotPagesStocktransactionCreateRoute
  '/_authenticated/stocktransaction/list': typeof DotDotDotDotPagesStocktransactionListRoute
  '/_authenticated/supplier/$id': typeof DotDotDotDotPagesSupplierChar91idChar93Route
  '/_authenticated/supplier/create': typeof DotDotDotDotPagesSupplierCreateRoute
  '/_authenticated/supplier/list': typeof DotDotDotDotPagesSupplierListRoute
  '/_authenticated/van/create': typeof DotDotDotDotPagesVanCreateRoute
  '/_authenticated/van/list': typeof DotDotDotDotPagesVanListRoute
  '/_authenticated/stock-take/$id': typeof DotDotDotDotPagesStockTakeChar91idChar93IndexRoute
  '/_authenticated/van/$id': typeof DotDotDotDotPagesVanChar91idChar93IndexRoute
  '/_authenticated/invoice/view/$id': typeof DotDotDotDotPagesInvoiceViewChar91idChar93Route
  '/_authenticated/message/bulk/$id': typeof DotDotDotDotPagesMessageBulkChar91idChar93Route
  '/_authenticated/message/bulk/create': typeof DotDotDotDotPagesMessageBulkCreateRoute
  '/_authenticated/quote/view/$id': typeof DotDotDotDotPagesQuoteViewChar91idChar93Route
  '/_authenticated/settings/api/manage': typeof DotDotDotDotPagesSettingsApiManageRoute
  '/_authenticated/settings/asset/manage': typeof DotDotDotDotPagesSettingsAssetManageRoute
  '/_authenticated/settings/company/manage': typeof DotDotDotDotPagesSettingsCompanyManageRoute
  '/_authenticated/settings/customer/manage': typeof DotDotDotDotPagesSettingsCustomerManageRoute
  '/_authenticated/settings/document/manage': typeof DotDotDotDotPagesSettingsDocumentManageRoute
  '/_authenticated/settings/employee/$id': typeof DotDotDotDotPagesSettingsEmployeeChar91idChar93Route
  '/_authenticated/settings/employee/create': typeof DotDotDotDotPagesSettingsEmployeeCreateRoute
  '/_authenticated/settings/employee/list': typeof DotDotDotDotPagesSettingsEmployeeListRoute
  '/_authenticated/settings/form/$id': typeof DotDotDotDotPagesSettingsFormChar91idChar93Route
  '/_authenticated/settings/form/create': typeof DotDotDotDotPagesSettingsFormCreateRoute
  '/_authenticated/settings/form/list': typeof DotDotDotDotPagesSettingsFormListRoute
  '/_authenticated/settings/import/create': typeof DotDotDotDotPagesSettingsImportCreateRoute
  '/_authenticated/settings/import/list': typeof DotDotDotDotPagesSettingsImportListRoute
  '/_authenticated/settings/import/smart': typeof DotDotDotDotPagesSettingsImportSmartImportRoute
  '/_authenticated/settings/integration/manage': typeof DotDotDotDotPagesSettingsIntegrationManageRoute
  '/_authenticated/settings/integration/oauthqbo': typeof DotDotDotDotPagesSettingsIntegrationOauthqboRoute
  '/_authenticated/settings/integration/oauthsageone': typeof DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute
  '/_authenticated/settings/integration/oauthxero': typeof DotDotDotDotPagesSettingsIntegrationOauthxeroRoute
  '/_authenticated/settings/inventory/manage': typeof DotDotDotDotPagesSettingsInventoryManageRoute
  '/_authenticated/settings/invoice/manage': typeof DotDotDotDotPagesSettingsInvoiceManageRoute
  '/_authenticated/settings/job/manage': typeof DotDotDotDotPagesSettingsJobManageRoute
  '/_authenticated/settings/option/$id': typeof DotDotDotDotPagesSettingsOptionChar91idChar93Route
  '/_authenticated/settings/option/create': typeof DotDotDotDotPagesSettingsOptionCreateRoute
  '/_authenticated/settings/option/list': typeof DotDotDotDotPagesSettingsOptionListRoute
  '/_authenticated/settings/payment/payfast': typeof DotDotDotDotPagesSettingsPaymentPayfastRoute
  '/_authenticated/settings/project/manage': typeof DotDotDotDotPagesSettingsProjectManageRoute
  '/_authenticated/settings/purchase/manage': typeof DotDotDotDotPagesSettingsPurchaseManageRoute
  '/_authenticated/settings/query/manage': typeof DotDotDotDotPagesSettingsQueryManageRoute
  '/_authenticated/settings/quote/manage': typeof DotDotDotDotPagesSettingsQuoteManageRoute
  '/_authenticated/settings/signaturetemplate/$id': typeof DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route
  '/_authenticated/settings/signaturetemplate/create': typeof DotDotDotDotPagesSettingsSignaturetemplateCreateRoute
  '/_authenticated/settings/signaturetemplate/list': typeof DotDotDotDotPagesSettingsSignaturetemplateListRoute
  '/_authenticated/settings/store/$id': typeof DotDotDotDotPagesSettingsStoreChar91idChar93Route
  '/_authenticated/settings/store/create': typeof DotDotDotDotPagesSettingsStoreCreateRoute
  '/_authenticated/settings/store/list': typeof DotDotDotDotPagesSettingsStoreListRoute
  '/_authenticated/settings/subscription/cancel': typeof DotDotDotDotPagesSettingsSubscriptionCancelRoute
  '/_authenticated/settings/subscription/manage': typeof DotDotDotDotPagesSettingsSubscriptionManageRoute
  '/_authenticated/settings/subscription/peach': typeof DotDotDotDotPagesSettingsSubscriptionPeachRoute
  '/_authenticated/settings/subscription/success': typeof DotDotDotDotPagesSettingsSubscriptionSuccessRoute
  '/_authenticated/settings/task/$id': typeof DotDotDotDotPagesSettingsTaskChar91idChar93Route
  '/_authenticated/settings/task/create': typeof DotDotDotDotPagesSettingsTaskCreateRoute
  '/_authenticated/settings/task/list': typeof DotDotDotDotPagesSettingsTaskListRoute
  '/_authenticated/settings/template/$id': typeof DotDotDotDotPagesSettingsTemplateChar91idChar93Route
  '/_authenticated/settings/template/create': typeof DotDotDotDotPagesSettingsTemplateCreateRoute
  '/_authenticated/settings/template/edit': typeof DotDotDotDotPagesSettingsTemplateEditRoute
  '/_authenticated/settings/template/list': typeof DotDotDotDotPagesSettingsTemplateListRoute
  '/_authenticated/settings/trigger/$id': typeof DotDotDotDotPagesSettingsTriggerChar91idChar93Route
  '/_authenticated/settings/trigger/create': typeof DotDotDotDotPagesSettingsTriggerCreateRoute
  '/_authenticated/settings/trigger/list': typeof DotDotDotDotPagesSettingsTriggerListRoute
  '/_authenticated/settings/warehouse/$id': typeof DotDotDotDotPagesSettingsWarehouseChar91idChar93Route
  '/_authenticated/settings/warehouse/create': typeof DotDotDotDotPagesSettingsWarehouseCreateRoute
  '/_authenticated/settings/warehouse/list': typeof DotDotDotDotPagesSettingsWarehouseListRoute
  '/_authenticated/settings/webform/$id': typeof DotDotDotDotPagesSettingsWebformChar91idChar93Route
  '/_authenticated/settings/webform/create': typeof DotDotDotDotPagesSettingsWebformCreateRoute
  '/_authenticated/settings/webform/list': typeof DotDotDotDotPagesSettingsWebformListRoute
  '/_authenticated/stock-take/$id/copy': typeof DotDotDotDotPagesStockTakeChar91idChar93CopyRoute
  '/_authenticated/stock-take/$id/edit': typeof DotDotDotDotPagesStockTakeChar91idChar93EditRoute
  '/_authenticated/stock-take/template/$id': typeof DotDotDotDotPagesStockTakeTemplateChar91idChar93Route
  '/_authenticated/stock-take/template/create': typeof DotDotDotDotPagesStockTakeTemplateCreateRoute
  '/_authenticated/stocktransaction/adjustment/list': typeof DotDotDotDotPagesStocktransactionAdjustmentListRoute
  '/_authenticated/stocktransaction/external-transfer/list': typeof DotDotDotDotPagesStocktransactionExternalTransferListRoute
  '/_authenticated/stocktransaction/grv/list': typeof DotDotDotDotPagesStocktransactionGrvListRoute
  '/_authenticated/stocktransaction/transfer/list': typeof DotDotDotDotPagesStocktransactionTransferListRoute
  '/_authenticated/van/$id/edit': typeof DotDotDotDotPagesVanChar91idChar93EditRoute
  '/webform/$origin/$key/$api': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute
  '/webform/$origin/$key/$api/$css': typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/complete-invite'
    | '/complete-signup'
    | '/debit-order'
    | '/login'
    | '/sign-up-icp'
    | '/verify'
    | '/activate'
    | '/customerzone'
    | '/reset-password'
    | '/webform'
    | '/admin'
    | '/customerzone/appointmentlist'
    | '/customerzone/invoicelist'
    | '/customerzone/jobfeedback'
    | '/customerzone/joblist'
    | '/customerzone/quotelist'
    | '/customerzone/sageinvoicelist'
    | '/customerzone/signature'
    | '/customerzone/viewappointment'
    | '/customerzone/viewinvoice'
    | '/customerzone/viewjob'
    | '/customerzone/viewquote'
    | '/i/$token'
    | '/tenantzone/signature'
    | '/appointment'
    | '/feedbear'
    | '/appointment/list'
    | '/appointment/scheduler'
    | '/asset/$id'
    | '/asset/create'
    | '/asset/list'
    | '/attachment/list'
    | '/bundle/$id'
    | '/bundle/create'
    | '/customer/$id'
    | '/customer/create'
    | '/customer/list'
    | '/inventory-category/$id'
    | '/inventory-category/create'
    | '/inventory-category/list'
    | '/inventory-subcategory/$id'
    | '/inventory-subcategory/create'
    | '/inventory-subcategory/list'
    | '/inventory/$id'
    | '/inventory/create'
    | '/inventory/list'
    | '/invoice/$id'
    | '/invoice/create'
    | '/invoice/list'
    | '/job-schedule/$id'
    | '/job-schedule/create'
    | '/job-schedule/list'
    | '/job/$id'
    | '/job/create'
    | '/job/job-map'
    | '/job/list'
    | '/message/list'
    | '/new-communication/$id'
    | '/project/$id'
    | '/project/create'
    | '/project/list'
    | '/purchase/$id'
    | '/purchase/create'
    | '/purchase/list'
    | '/query/$id'
    | '/query/create'
    | '/query/list'
    | '/quote/$id'
    | '/quote/create'
    | '/quote/list'
    | '/report/list'
    | '/settings/change-password'
    | '/settings/job-status'
    | '/settings/role-settings'
    | '/stock-take/create'
    | '/stock-take/list'
    | '/stocktransaction/$id'
    | '/stocktransaction/create'
    | '/stocktransaction/list'
    | '/supplier/$id'
    | '/supplier/create'
    | '/supplier/list'
    | '/van/create'
    | '/van/list'
    | '/stock-take/$id'
    | '/van/$id'
    | '/invoice/view/$id'
    | '/message/bulk/$id'
    | '/message/bulk/create'
    | '/quote/view/$id'
    | '/settings/api/manage'
    | '/settings/asset/manage'
    | '/settings/company/manage'
    | '/settings/customer/manage'
    | '/settings/document/manage'
    | '/settings/employee/$id'
    | '/settings/employee/create'
    | '/settings/employee/list'
    | '/settings/form/$id'
    | '/settings/form/create'
    | '/settings/form/list'
    | '/settings/import/create'
    | '/settings/import/list'
    | '/settings/import/smart'
    | '/settings/integration/manage'
    | '/settings/integration/oauthqbo'
    | '/settings/integration/oauthsageone'
    | '/settings/integration/oauthxero'
    | '/settings/inventory/manage'
    | '/settings/invoice/manage'
    | '/settings/job/manage'
    | '/settings/option/$id'
    | '/settings/option/create'
    | '/settings/option/list'
    | '/settings/payment/payfast'
    | '/settings/project/manage'
    | '/settings/purchase/manage'
    | '/settings/query/manage'
    | '/settings/quote/manage'
    | '/settings/signaturetemplate/$id'
    | '/settings/signaturetemplate/create'
    | '/settings/signaturetemplate/list'
    | '/settings/store/$id'
    | '/settings/store/create'
    | '/settings/store/list'
    | '/settings/subscription/cancel'
    | '/settings/subscription/manage'
    | '/settings/subscription/peach'
    | '/settings/subscription/success'
    | '/settings/task/$id'
    | '/settings/task/create'
    | '/settings/task/list'
    | '/settings/template/$id'
    | '/settings/template/create'
    | '/settings/template/edit'
    | '/settings/template/list'
    | '/settings/trigger/$id'
    | '/settings/trigger/create'
    | '/settings/trigger/list'
    | '/settings/warehouse/$id'
    | '/settings/warehouse/create'
    | '/settings/warehouse/list'
    | '/settings/webform/$id'
    | '/settings/webform/create'
    | '/settings/webform/list'
    | '/stock-take/$id/copy'
    | '/stock-take/$id/edit'
    | '/stock-take/template/$id'
    | '/stock-take/template/create'
    | '/stocktransaction/adjustment/list'
    | '/stocktransaction/external-transfer/list'
    | '/stocktransaction/grv/list'
    | '/stocktransaction/transfer/list'
    | '/van/$id/edit'
    | '/webform/$origin/$key/$api'
    | '/webform/$origin/$key/$api/$css'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/complete-invite'
    | '/complete-signup'
    | '/debit-order'
    | '/login'
    | '/sign-up-icp'
    | '/verify'
    | '/activate'
    | '/customerzone'
    | '/reset-password'
    | '/webform'
    | '/admin'
    | '/customerzone/appointmentlist'
    | '/customerzone/invoicelist'
    | '/customerzone/jobfeedback'
    | '/customerzone/joblist'
    | '/customerzone/quotelist'
    | '/customerzone/sageinvoicelist'
    | '/customerzone/signature'
    | '/customerzone/viewappointment'
    | '/customerzone/viewinvoice'
    | '/customerzone/viewjob'
    | '/customerzone/viewquote'
    | '/i/$token'
    | '/tenantzone/signature'
    | '/'
    | '/appointment'
    | '/feedbear'
    | '/appointment/list'
    | '/appointment/scheduler'
    | '/asset/$id'
    | '/asset/create'
    | '/asset/list'
    | '/attachment/list'
    | '/bundle/$id'
    | '/bundle/create'
    | '/customer/$id'
    | '/customer/create'
    | '/customer/list'
    | '/inventory-category/$id'
    | '/inventory-category/create'
    | '/inventory-category/list'
    | '/inventory-subcategory/$id'
    | '/inventory-subcategory/create'
    | '/inventory-subcategory/list'
    | '/inventory/$id'
    | '/inventory/create'
    | '/inventory/list'
    | '/invoice/$id'
    | '/invoice/create'
    | '/invoice/list'
    | '/job-schedule/$id'
    | '/job-schedule/create'
    | '/job-schedule/list'
    | '/job/$id'
    | '/job/create'
    | '/job/job-map'
    | '/job/list'
    | '/message/list'
    | '/new-communication/$id'
    | '/project/$id'
    | '/project/create'
    | '/project/list'
    | '/purchase/$id'
    | '/purchase/create'
    | '/purchase/list'
    | '/query/$id'
    | '/query/create'
    | '/query/list'
    | '/quote/$id'
    | '/quote/create'
    | '/quote/list'
    | '/report/list'
    | '/settings/change-password'
    | '/settings/job-status'
    | '/settings/role-settings'
    | '/stock-take/create'
    | '/stock-take/list'
    | '/stocktransaction/$id'
    | '/stocktransaction/create'
    | '/stocktransaction/list'
    | '/supplier/$id'
    | '/supplier/create'
    | '/supplier/list'
    | '/van/create'
    | '/van/list'
    | '/stock-take/$id'
    | '/van/$id'
    | '/invoice/view/$id'
    | '/message/bulk/$id'
    | '/message/bulk/create'
    | '/quote/view/$id'
    | '/settings/api/manage'
    | '/settings/asset/manage'
    | '/settings/company/manage'
    | '/settings/customer/manage'
    | '/settings/document/manage'
    | '/settings/employee/$id'
    | '/settings/employee/create'
    | '/settings/employee/list'
    | '/settings/form/$id'
    | '/settings/form/create'
    | '/settings/form/list'
    | '/settings/import/create'
    | '/settings/import/list'
    | '/settings/import/smart'
    | '/settings/integration/manage'
    | '/settings/integration/oauthqbo'
    | '/settings/integration/oauthsageone'
    | '/settings/integration/oauthxero'
    | '/settings/inventory/manage'
    | '/settings/invoice/manage'
    | '/settings/job/manage'
    | '/settings/option/$id'
    | '/settings/option/create'
    | '/settings/option/list'
    | '/settings/payment/payfast'
    | '/settings/project/manage'
    | '/settings/purchase/manage'
    | '/settings/query/manage'
    | '/settings/quote/manage'
    | '/settings/signaturetemplate/$id'
    | '/settings/signaturetemplate/create'
    | '/settings/signaturetemplate/list'
    | '/settings/store/$id'
    | '/settings/store/create'
    | '/settings/store/list'
    | '/settings/subscription/cancel'
    | '/settings/subscription/manage'
    | '/settings/subscription/peach'
    | '/settings/subscription/success'
    | '/settings/task/$id'
    | '/settings/task/create'
    | '/settings/task/list'
    | '/settings/template/$id'
    | '/settings/template/create'
    | '/settings/template/edit'
    | '/settings/template/list'
    | '/settings/trigger/$id'
    | '/settings/trigger/create'
    | '/settings/trigger/list'
    | '/settings/warehouse/$id'
    | '/settings/warehouse/create'
    | '/settings/warehouse/list'
    | '/settings/webform/$id'
    | '/settings/webform/create'
    | '/settings/webform/list'
    | '/stock-take/$id/copy'
    | '/stock-take/$id/edit'
    | '/stock-take/template/$id'
    | '/stock-take/template/create'
    | '/stocktransaction/adjustment/list'
    | '/stocktransaction/external-transfer/list'
    | '/stocktransaction/grv/list'
    | '/stocktransaction/transfer/list'
    | '/van/$id/edit'
    | '/webform/$origin/$key/$api'
    | '/webform/$origin/$key/$api/$css'
  id:
    | '__root__'
    | '/_authenticated'
    | '/complete-invite'
    | '/complete-signup'
    | '/debit-order'
    | '/login'
    | '/sign-up-icp'
    | '/verify'
    | '/activate'
    | '/customerzone'
    | '/reset-password'
    | '/webform'
    | '/_authenticated/admin'
    | '/customerzone/appointmentlist'
    | '/customerzone/invoicelist'
    | '/customerzone/jobfeedback'
    | '/customerzone/joblist'
    | '/customerzone/quotelist'
    | '/customerzone/sageinvoicelist'
    | '/customerzone/signature'
    | '/customerzone/viewappointment'
    | '/customerzone/viewinvoice'
    | '/customerzone/viewjob'
    | '/customerzone/viewquote'
    | '/i/$token'
    | '/tenantzone/signature'
    | '/_authenticated/'
    | '/_authenticated/appointment'
    | '/_authenticated/feedbear'
    | '/_authenticated/appointment/list'
    | '/_authenticated/appointment/scheduler'
    | '/_authenticated/asset/$id'
    | '/_authenticated/asset/create'
    | '/_authenticated/asset/list'
    | '/_authenticated/attachment/list'
    | '/_authenticated/bundle/$id'
    | '/_authenticated/bundle/create'
    | '/_authenticated/customer/$id'
    | '/_authenticated/customer/create'
    | '/_authenticated/customer/list'
    | '/_authenticated/inventory-category/$id'
    | '/_authenticated/inventory-category/create'
    | '/_authenticated/inventory-category/list'
    | '/_authenticated/inventory-subcategory/$id'
    | '/_authenticated/inventory-subcategory/create'
    | '/_authenticated/inventory-subcategory/list'
    | '/_authenticated/inventory/$id'
    | '/_authenticated/inventory/create'
    | '/_authenticated/inventory/list'
    | '/_authenticated/invoice/$id'
    | '/_authenticated/invoice/create'
    | '/_authenticated/invoice/list'
    | '/_authenticated/job-schedule/$id'
    | '/_authenticated/job-schedule/create'
    | '/_authenticated/job-schedule/list'
    | '/_authenticated/job/$id'
    | '/_authenticated/job/create'
    | '/_authenticated/job/job-map'
    | '/_authenticated/job/list'
    | '/_authenticated/message/list'
    | '/_authenticated/new-communication/$id'
    | '/_authenticated/project/$id'
    | '/_authenticated/project/create'
    | '/_authenticated/project/list'
    | '/_authenticated/purchase/$id'
    | '/_authenticated/purchase/create'
    | '/_authenticated/purchase/list'
    | '/_authenticated/query/$id'
    | '/_authenticated/query/create'
    | '/_authenticated/query/list'
    | '/_authenticated/quote/$id'
    | '/_authenticated/quote/create'
    | '/_authenticated/quote/list'
    | '/_authenticated/report/list'
    | '/_authenticated/settings/change-password'
    | '/_authenticated/settings/job-status'
    | '/_authenticated/settings/role-settings'
    | '/_authenticated/stock-take/create'
    | '/_authenticated/stock-take/list'
    | '/_authenticated/stocktransaction/$id'
    | '/_authenticated/stocktransaction/create'
    | '/_authenticated/stocktransaction/list'
    | '/_authenticated/supplier/$id'
    | '/_authenticated/supplier/create'
    | '/_authenticated/supplier/list'
    | '/_authenticated/van/create'
    | '/_authenticated/van/list'
    | '/_authenticated/stock-take/$id'
    | '/_authenticated/van/$id'
    | '/_authenticated/invoice/view/$id'
    | '/_authenticated/message/bulk/$id'
    | '/_authenticated/message/bulk/create'
    | '/_authenticated/quote/view/$id'
    | '/_authenticated/settings/api/manage'
    | '/_authenticated/settings/asset/manage'
    | '/_authenticated/settings/company/manage'
    | '/_authenticated/settings/customer/manage'
    | '/_authenticated/settings/document/manage'
    | '/_authenticated/settings/employee/$id'
    | '/_authenticated/settings/employee/create'
    | '/_authenticated/settings/employee/list'
    | '/_authenticated/settings/form/$id'
    | '/_authenticated/settings/form/create'
    | '/_authenticated/settings/form/list'
    | '/_authenticated/settings/import/create'
    | '/_authenticated/settings/import/list'
    | '/_authenticated/settings/import/smart'
    | '/_authenticated/settings/integration/manage'
    | '/_authenticated/settings/integration/oauthqbo'
    | '/_authenticated/settings/integration/oauthsageone'
    | '/_authenticated/settings/integration/oauthxero'
    | '/_authenticated/settings/inventory/manage'
    | '/_authenticated/settings/invoice/manage'
    | '/_authenticated/settings/job/manage'
    | '/_authenticated/settings/option/$id'
    | '/_authenticated/settings/option/create'
    | '/_authenticated/settings/option/list'
    | '/_authenticated/settings/payment/payfast'
    | '/_authenticated/settings/project/manage'
    | '/_authenticated/settings/purchase/manage'
    | '/_authenticated/settings/query/manage'
    | '/_authenticated/settings/quote/manage'
    | '/_authenticated/settings/signaturetemplate/$id'
    | '/_authenticated/settings/signaturetemplate/create'
    | '/_authenticated/settings/signaturetemplate/list'
    | '/_authenticated/settings/store/$id'
    | '/_authenticated/settings/store/create'
    | '/_authenticated/settings/store/list'
    | '/_authenticated/settings/subscription/cancel'
    | '/_authenticated/settings/subscription/manage'
    | '/_authenticated/settings/subscription/peach'
    | '/_authenticated/settings/subscription/success'
    | '/_authenticated/settings/task/$id'
    | '/_authenticated/settings/task/create'
    | '/_authenticated/settings/task/list'
    | '/_authenticated/settings/template/$id'
    | '/_authenticated/settings/template/create'
    | '/_authenticated/settings/template/edit'
    | '/_authenticated/settings/template/list'
    | '/_authenticated/settings/trigger/$id'
    | '/_authenticated/settings/trigger/create'
    | '/_authenticated/settings/trigger/list'
    | '/_authenticated/settings/warehouse/$id'
    | '/_authenticated/settings/warehouse/create'
    | '/_authenticated/settings/warehouse/list'
    | '/_authenticated/settings/webform/$id'
    | '/_authenticated/settings/webform/create'
    | '/_authenticated/settings/webform/list'
    | '/_authenticated/stock-take/$id/copy'
    | '/_authenticated/stock-take/$id/edit'
    | '/_authenticated/stock-take/template/$id'
    | '/_authenticated/stock-take/template/create'
    | '/_authenticated/stocktransaction/adjustment/list'
    | '/_authenticated/stocktransaction/external-transfer/list'
    | '/_authenticated/stocktransaction/grv/list'
    | '/_authenticated/stocktransaction/transfer/list'
    | '/_authenticated/van/$id/edit'
    | '/webform/$origin/$key/$api'
    | '/webform/$origin/$key/$api/$css'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authenticatedRoute: typeof authenticatedRouteWithChildren
  DotDotDotDotPagesCompleteInviteRoute: typeof DotDotDotDotPagesCompleteInviteRoute
  DotDotDotDotPagesCompleteSignupRoute: typeof DotDotDotDotPagesCompleteSignupRoute
  DotDotDotDotPagesDebitOrderRoute: typeof DotDotDotDotPagesDebitOrderRoute
  loginRoute: typeof loginRoute
  DotDotDotDotPagesSignUpIcpRoute: typeof DotDotDotDotPagesSignUpIcpRoute
  DotDotDotDotPagesVerifyRoute: typeof DotDotDotDotPagesVerifyRoute
  DotDotDotDotPagesActivateIndexRoute: typeof DotDotDotDotPagesActivateIndexRoute
  DotDotDotDotPagesCustomerzoneIndexRoute: typeof DotDotDotDotPagesCustomerzoneIndexRoute
  DotDotDotDotPagesResetPasswordIndexRoute: typeof DotDotDotDotPagesResetPasswordIndexRoute
  DotDotDotDotPagesWebformIndexRoute: typeof DotDotDotDotPagesWebformIndexRoute
  DotDotDotDotPagesCustomerzoneAppointmentlistRoute: typeof DotDotDotDotPagesCustomerzoneAppointmentlistRoute
  DotDotDotDotPagesCustomerzoneInvoicelistRoute: typeof DotDotDotDotPagesCustomerzoneInvoicelistRoute
  DotDotDotDotPagesCustomerzoneJobfeedbackRoute: typeof DotDotDotDotPagesCustomerzoneJobfeedbackRoute
  DotDotDotDotPagesCustomerzoneJoblistRoute: typeof DotDotDotDotPagesCustomerzoneJoblistRoute
  DotDotDotDotPagesCustomerzoneQuotelistRoute: typeof DotDotDotDotPagesCustomerzoneQuotelistRoute
  DotDotDotDotPagesCustomerzoneSageinvoicelistRoute: typeof DotDotDotDotPagesCustomerzoneSageinvoicelistRoute
  DotDotDotDotPagesCustomerzoneSignatureRoute: typeof DotDotDotDotPagesCustomerzoneSignatureRoute
  DotDotDotDotPagesCustomerzoneViewappointmentRoute: typeof DotDotDotDotPagesCustomerzoneViewappointmentRoute
  DotDotDotDotPagesCustomerzoneViewinvoiceRoute: typeof DotDotDotDotPagesCustomerzoneViewinvoiceRoute
  DotDotDotDotPagesCustomerzoneViewjobRoute: typeof DotDotDotDotPagesCustomerzoneViewjobRoute
  DotDotDotDotPagesCustomerzoneViewquoteRoute: typeof DotDotDotDotPagesCustomerzoneViewquoteRoute
  DotDotDotDotPagesIChar91tokenChar93Route: typeof DotDotDotDotPagesIChar91tokenChar93Route
  DotDotDotDotPagesTenantzoneSignatureRoute: typeof DotDotDotDotPagesTenantzoneSignatureRoute
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute: typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute: typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/webform': {
      id: '/webform'
      path: '/webform'
      fullPath: '/webform'
      preLoaderRoute: typeof DotDotDotDotPagesWebformIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof DotDotDotDotPagesResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone': {
      id: '/customerzone'
      path: '/customerzone'
      fullPath: '/customerzone'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof DotDotDotDotPagesActivateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof DotDotDotDotPagesVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up-icp': {
      id: '/sign-up-icp'
      path: '/sign-up-icp'
      fullPath: '/sign-up-icp'
      preLoaderRoute: typeof DotDotDotDotPagesSignUpIcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof loginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debit-order': {
      id: '/debit-order'
      path: '/debit-order'
      fullPath: '/debit-order'
      preLoaderRoute: typeof DotDotDotDotPagesDebitOrderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-signup': {
      id: '/complete-signup'
      path: '/complete-signup'
      fullPath: '/complete-signup'
      preLoaderRoute: typeof DotDotDotDotPagesCompleteSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-invite': {
      id: '/complete-invite'
      path: '/complete-invite'
      fullPath: '/complete-invite'
      preLoaderRoute: typeof DotDotDotDotPagesCompleteInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof authenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/feedbear': {
      id: '/_authenticated/feedbear'
      path: '/feedbear'
      fullPath: '/feedbear'
      preLoaderRoute: typeof DotDotDotDotPagesFeedbearIndexRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/appointment': {
      id: '/_authenticated/appointment'
      path: '/appointment'
      fullPath: '/appointment'
      preLoaderRoute: typeof DotDotDotDotPagesAppointmentIndexRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DotDotDotDotPagesIndexRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/tenantzone/signature': {
      id: '/tenantzone/signature'
      path: '/tenantzone/signature'
      fullPath: '/tenantzone/signature'
      preLoaderRoute: typeof DotDotDotDotPagesTenantzoneSignatureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof DotDotDotDotPagesIChar91tokenChar93RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/viewquote': {
      id: '/customerzone/viewquote'
      path: '/customerzone/viewquote'
      fullPath: '/customerzone/viewquote'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneViewquoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/viewjob': {
      id: '/customerzone/viewjob'
      path: '/customerzone/viewjob'
      fullPath: '/customerzone/viewjob'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneViewjobRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/viewinvoice': {
      id: '/customerzone/viewinvoice'
      path: '/customerzone/viewinvoice'
      fullPath: '/customerzone/viewinvoice'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneViewinvoiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/viewappointment': {
      id: '/customerzone/viewappointment'
      path: '/customerzone/viewappointment'
      fullPath: '/customerzone/viewappointment'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneViewappointmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/signature': {
      id: '/customerzone/signature'
      path: '/customerzone/signature'
      fullPath: '/customerzone/signature'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneSignatureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/sageinvoicelist': {
      id: '/customerzone/sageinvoicelist'
      path: '/customerzone/sageinvoicelist'
      fullPath: '/customerzone/sageinvoicelist'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneSageinvoicelistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/quotelist': {
      id: '/customerzone/quotelist'
      path: '/customerzone/quotelist'
      fullPath: '/customerzone/quotelist'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneQuotelistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/joblist': {
      id: '/customerzone/joblist'
      path: '/customerzone/joblist'
      fullPath: '/customerzone/joblist'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneJoblistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/jobfeedback': {
      id: '/customerzone/jobfeedback'
      path: '/customerzone/jobfeedback'
      fullPath: '/customerzone/jobfeedback'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneJobfeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/invoicelist': {
      id: '/customerzone/invoicelist'
      path: '/customerzone/invoicelist'
      fullPath: '/customerzone/invoicelist'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneInvoicelistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customerzone/appointmentlist': {
      id: '/customerzone/appointmentlist'
      path: '/customerzone/appointmentlist'
      fullPath: '/customerzone/appointmentlist'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerzoneAppointmentlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof DotDotDotDotPagesAdminRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/van/$id': {
      id: '/_authenticated/van/$id'
      path: '/van/$id'
      fullPath: '/van/$id'
      preLoaderRoute: typeof DotDotDotDotPagesVanChar91idChar93IndexRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/$id': {
      id: '/_authenticated/stock-take/$id'
      path: '/stock-take/$id'
      fullPath: '/stock-take/$id'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93IndexRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/van/list': {
      id: '/_authenticated/van/list'
      path: '/van/list'
      fullPath: '/van/list'
      preLoaderRoute: typeof DotDotDotDotPagesVanListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/van/create': {
      id: '/_authenticated/van/create'
      path: '/van/create'
      fullPath: '/van/create'
      preLoaderRoute: typeof DotDotDotDotPagesVanCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/supplier/list': {
      id: '/_authenticated/supplier/list'
      path: '/supplier/list'
      fullPath: '/supplier/list'
      preLoaderRoute: typeof DotDotDotDotPagesSupplierListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/supplier/create': {
      id: '/_authenticated/supplier/create'
      path: '/supplier/create'
      fullPath: '/supplier/create'
      preLoaderRoute: typeof DotDotDotDotPagesSupplierCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/supplier/$id': {
      id: '/_authenticated/supplier/$id'
      path: '/supplier/$id'
      fullPath: '/supplier/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSupplierChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/list': {
      id: '/_authenticated/stocktransaction/list'
      path: '/stocktransaction/list'
      fullPath: '/stocktransaction/list'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/create': {
      id: '/_authenticated/stocktransaction/create'
      path: '/stocktransaction/create'
      fullPath: '/stocktransaction/create'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/$id': {
      id: '/_authenticated/stocktransaction/$id'
      path: '/stocktransaction/$id'
      fullPath: '/stocktransaction/$id'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/list': {
      id: '/_authenticated/stock-take/list'
      path: '/stock-take/list'
      fullPath: '/stock-take/list'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/create': {
      id: '/_authenticated/stock-take/create'
      path: '/stock-take/create'
      fullPath: '/stock-take/create'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/role-settings': {
      id: '/_authenticated/settings/role-settings'
      path: '/settings/role-settings'
      fullPath: '/settings/role-settings'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsRoleSettingsRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/job-status': {
      id: '/_authenticated/settings/job-status'
      path: '/settings/job-status'
      fullPath: '/settings/job-status'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsJobStatusRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/change-password': {
      id: '/_authenticated/settings/change-password'
      path: '/settings/change-password'
      fullPath: '/settings/change-password'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsChangePasswordRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/report/list': {
      id: '/_authenticated/report/list'
      path: '/report/list'
      fullPath: '/report/list'
      preLoaderRoute: typeof DotDotDotDotPagesReportListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/quote/list': {
      id: '/_authenticated/quote/list'
      path: '/quote/list'
      fullPath: '/quote/list'
      preLoaderRoute: typeof DotDotDotDotPagesQuoteListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/quote/create': {
      id: '/_authenticated/quote/create'
      path: '/quote/create'
      fullPath: '/quote/create'
      preLoaderRoute: typeof DotDotDotDotPagesQuoteCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/quote/$id': {
      id: '/_authenticated/quote/$id'
      path: '/quote/$id'
      fullPath: '/quote/$id'
      preLoaderRoute: typeof DotDotDotDotPagesQuoteChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/query/list': {
      id: '/_authenticated/query/list'
      path: '/query/list'
      fullPath: '/query/list'
      preLoaderRoute: typeof DotDotDotDotPagesQueryListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/query/create': {
      id: '/_authenticated/query/create'
      path: '/query/create'
      fullPath: '/query/create'
      preLoaderRoute: typeof DotDotDotDotPagesQueryCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/query/$id': {
      id: '/_authenticated/query/$id'
      path: '/query/$id'
      fullPath: '/query/$id'
      preLoaderRoute: typeof DotDotDotDotPagesQueryChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/purchase/list': {
      id: '/_authenticated/purchase/list'
      path: '/purchase/list'
      fullPath: '/purchase/list'
      preLoaderRoute: typeof DotDotDotDotPagesPurchaseListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/purchase/create': {
      id: '/_authenticated/purchase/create'
      path: '/purchase/create'
      fullPath: '/purchase/create'
      preLoaderRoute: typeof DotDotDotDotPagesPurchaseCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/purchase/$id': {
      id: '/_authenticated/purchase/$id'
      path: '/purchase/$id'
      fullPath: '/purchase/$id'
      preLoaderRoute: typeof DotDotDotDotPagesPurchaseChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/project/list': {
      id: '/_authenticated/project/list'
      path: '/project/list'
      fullPath: '/project/list'
      preLoaderRoute: typeof DotDotDotDotPagesProjectListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/project/create': {
      id: '/_authenticated/project/create'
      path: '/project/create'
      fullPath: '/project/create'
      preLoaderRoute: typeof DotDotDotDotPagesProjectCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/project/$id': {
      id: '/_authenticated/project/$id'
      path: '/project/$id'
      fullPath: '/project/$id'
      preLoaderRoute: typeof DotDotDotDotPagesProjectChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/new-communication/$id': {
      id: '/_authenticated/new-communication/$id'
      path: '/new-communication/$id'
      fullPath: '/new-communication/$id'
      preLoaderRoute: typeof DotDotDotDotPagesNewCommunicationChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/message/list': {
      id: '/_authenticated/message/list'
      path: '/message/list'
      fullPath: '/message/list'
      preLoaderRoute: typeof DotDotDotDotPagesMessageListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job/list': {
      id: '/_authenticated/job/list'
      path: '/job/list'
      fullPath: '/job/list'
      preLoaderRoute: typeof DotDotDotDotPagesJobListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job/job-map': {
      id: '/_authenticated/job/job-map'
      path: '/job/job-map'
      fullPath: '/job/job-map'
      preLoaderRoute: typeof DotDotDotDotPagesJobJobMapRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job/create': {
      id: '/_authenticated/job/create'
      path: '/job/create'
      fullPath: '/job/create'
      preLoaderRoute: typeof DotDotDotDotPagesJobCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job/$id': {
      id: '/_authenticated/job/$id'
      path: '/job/$id'
      fullPath: '/job/$id'
      preLoaderRoute: typeof DotDotDotDotPagesJobChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job-schedule/list': {
      id: '/_authenticated/job-schedule/list'
      path: '/job-schedule/list'
      fullPath: '/job-schedule/list'
      preLoaderRoute: typeof DotDotDotDotPagesJobScheduleListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job-schedule/create': {
      id: '/_authenticated/job-schedule/create'
      path: '/job-schedule/create'
      fullPath: '/job-schedule/create'
      preLoaderRoute: typeof DotDotDotDotPagesJobScheduleCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/job-schedule/$id': {
      id: '/_authenticated/job-schedule/$id'
      path: '/job-schedule/$id'
      fullPath: '/job-schedule/$id'
      preLoaderRoute: typeof DotDotDotDotPagesJobScheduleChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/invoice/list': {
      id: '/_authenticated/invoice/list'
      path: '/invoice/list'
      fullPath: '/invoice/list'
      preLoaderRoute: typeof DotDotDotDotPagesInvoiceListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/invoice/create': {
      id: '/_authenticated/invoice/create'
      path: '/invoice/create'
      fullPath: '/invoice/create'
      preLoaderRoute: typeof DotDotDotDotPagesInvoiceCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/invoice/$id': {
      id: '/_authenticated/invoice/$id'
      path: '/invoice/$id'
      fullPath: '/invoice/$id'
      preLoaderRoute: typeof DotDotDotDotPagesInvoiceChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory/list': {
      id: '/_authenticated/inventory/list'
      path: '/inventory/list'
      fullPath: '/inventory/list'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory/create': {
      id: '/_authenticated/inventory/create'
      path: '/inventory/create'
      fullPath: '/inventory/create'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory/$id': {
      id: '/_authenticated/inventory/$id'
      path: '/inventory/$id'
      fullPath: '/inventory/$id'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-subcategory/list': {
      id: '/_authenticated/inventory-subcategory/list'
      path: '/inventory-subcategory/list'
      fullPath: '/inventory-subcategory/list'
      preLoaderRoute: typeof DotDotDotDotPagesInventorySubcategoryListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-subcategory/create': {
      id: '/_authenticated/inventory-subcategory/create'
      path: '/inventory-subcategory/create'
      fullPath: '/inventory-subcategory/create'
      preLoaderRoute: typeof DotDotDotDotPagesInventorySubcategoryCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-subcategory/$id': {
      id: '/_authenticated/inventory-subcategory/$id'
      path: '/inventory-subcategory/$id'
      fullPath: '/inventory-subcategory/$id'
      preLoaderRoute: typeof DotDotDotDotPagesInventorySubcategoryChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-category/list': {
      id: '/_authenticated/inventory-category/list'
      path: '/inventory-category/list'
      fullPath: '/inventory-category/list'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryCategoryListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-category/create': {
      id: '/_authenticated/inventory-category/create'
      path: '/inventory-category/create'
      fullPath: '/inventory-category/create'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryCategoryCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/inventory-category/$id': {
      id: '/_authenticated/inventory-category/$id'
      path: '/inventory-category/$id'
      fullPath: '/inventory-category/$id'
      preLoaderRoute: typeof DotDotDotDotPagesInventoryCategoryChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/customer/list': {
      id: '/_authenticated/customer/list'
      path: '/customer/list'
      fullPath: '/customer/list'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/customer/create': {
      id: '/_authenticated/customer/create'
      path: '/customer/create'
      fullPath: '/customer/create'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/customer/$id': {
      id: '/_authenticated/customer/$id'
      path: '/customer/$id'
      fullPath: '/customer/$id'
      preLoaderRoute: typeof DotDotDotDotPagesCustomerChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/bundle/create': {
      id: '/_authenticated/bundle/create'
      path: '/bundle/create'
      fullPath: '/bundle/create'
      preLoaderRoute: typeof DotDotDotDotPagesBundleCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/bundle/$id': {
      id: '/_authenticated/bundle/$id'
      path: '/bundle/$id'
      fullPath: '/bundle/$id'
      preLoaderRoute: typeof DotDotDotDotPagesBundleChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/attachment/list': {
      id: '/_authenticated/attachment/list'
      path: '/attachment/list'
      fullPath: '/attachment/list'
      preLoaderRoute: typeof DotDotDotDotPagesAttachmentListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/asset/list': {
      id: '/_authenticated/asset/list'
      path: '/asset/list'
      fullPath: '/asset/list'
      preLoaderRoute: typeof DotDotDotDotPagesAssetListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/asset/create': {
      id: '/_authenticated/asset/create'
      path: '/asset/create'
      fullPath: '/asset/create'
      preLoaderRoute: typeof DotDotDotDotPagesAssetCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/asset/$id': {
      id: '/_authenticated/asset/$id'
      path: '/asset/$id'
      fullPath: '/asset/$id'
      preLoaderRoute: typeof DotDotDotDotPagesAssetChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/appointment/scheduler': {
      id: '/_authenticated/appointment/scheduler'
      path: '/appointment/scheduler'
      fullPath: '/appointment/scheduler'
      preLoaderRoute: typeof DotDotDotDotPagesAppointmentSchedulerRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/appointment/list': {
      id: '/_authenticated/appointment/list'
      path: '/appointment/list'
      fullPath: '/appointment/list'
      preLoaderRoute: typeof appointmentListRedirectRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/webform/$origin/$key/$api': {
      id: '/webform/$origin/$key/$api'
      path: '/webform/$origin/$key/$api'
      fullPath: '/webform/$origin/$key/$api'
      preLoaderRoute: typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/van/$id/edit': {
      id: '/_authenticated/van/$id/edit'
      path: '/van/$id/edit'
      fullPath: '/van/$id/edit'
      preLoaderRoute: typeof DotDotDotDotPagesVanChar91idChar93EditRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/transfer/list': {
      id: '/_authenticated/stocktransaction/transfer/list'
      path: '/stocktransaction/transfer/list'
      fullPath: '/stocktransaction/transfer/list'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionTransferListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/grv/list': {
      id: '/_authenticated/stocktransaction/grv/list'
      path: '/stocktransaction/grv/list'
      fullPath: '/stocktransaction/grv/list'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionGrvListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/external-transfer/list': {
      id: '/_authenticated/stocktransaction/external-transfer/list'
      path: '/stocktransaction/external-transfer/list'
      fullPath: '/stocktransaction/external-transfer/list'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionExternalTransferListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stocktransaction/adjustment/list': {
      id: '/_authenticated/stocktransaction/adjustment/list'
      path: '/stocktransaction/adjustment/list'
      fullPath: '/stocktransaction/adjustment/list'
      preLoaderRoute: typeof DotDotDotDotPagesStocktransactionAdjustmentListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/template/create': {
      id: '/_authenticated/stock-take/template/create'
      path: '/stock-take/template/create'
      fullPath: '/stock-take/template/create'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeTemplateCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/template/$id': {
      id: '/_authenticated/stock-take/template/$id'
      path: '/stock-take/template/$id'
      fullPath: '/stock-take/template/$id'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeTemplateChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/$id/edit': {
      id: '/_authenticated/stock-take/$id/edit'
      path: '/stock-take/$id/edit'
      fullPath: '/stock-take/$id/edit'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93EditRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/stock-take/$id/copy': {
      id: '/_authenticated/stock-take/$id/copy'
      path: '/stock-take/$id/copy'
      fullPath: '/stock-take/$id/copy'
      preLoaderRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93CopyRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/webform/list': {
      id: '/_authenticated/settings/webform/list'
      path: '/settings/webform/list'
      fullPath: '/settings/webform/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWebformListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/webform/create': {
      id: '/_authenticated/settings/webform/create'
      path: '/settings/webform/create'
      fullPath: '/settings/webform/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWebformCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/webform/$id': {
      id: '/_authenticated/settings/webform/$id'
      path: '/settings/webform/$id'
      fullPath: '/settings/webform/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWebformChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/warehouse/list': {
      id: '/_authenticated/settings/warehouse/list'
      path: '/settings/warehouse/list'
      fullPath: '/settings/warehouse/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWarehouseListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/warehouse/create': {
      id: '/_authenticated/settings/warehouse/create'
      path: '/settings/warehouse/create'
      fullPath: '/settings/warehouse/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWarehouseCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/warehouse/$id': {
      id: '/_authenticated/settings/warehouse/$id'
      path: '/settings/warehouse/$id'
      fullPath: '/settings/warehouse/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsWarehouseChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/trigger/list': {
      id: '/_authenticated/settings/trigger/list'
      path: '/settings/trigger/list'
      fullPath: '/settings/trigger/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTriggerListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/trigger/create': {
      id: '/_authenticated/settings/trigger/create'
      path: '/settings/trigger/create'
      fullPath: '/settings/trigger/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTriggerCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/trigger/$id': {
      id: '/_authenticated/settings/trigger/$id'
      path: '/settings/trigger/$id'
      fullPath: '/settings/trigger/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTriggerChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/template/list': {
      id: '/_authenticated/settings/template/list'
      path: '/settings/template/list'
      fullPath: '/settings/template/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTemplateListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/template/edit': {
      id: '/_authenticated/settings/template/edit'
      path: '/settings/template/edit'
      fullPath: '/settings/template/edit'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTemplateEditRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/template/create': {
      id: '/_authenticated/settings/template/create'
      path: '/settings/template/create'
      fullPath: '/settings/template/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTemplateCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/template/$id': {
      id: '/_authenticated/settings/template/$id'
      path: '/settings/template/$id'
      fullPath: '/settings/template/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTemplateChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/task/list': {
      id: '/_authenticated/settings/task/list'
      path: '/settings/task/list'
      fullPath: '/settings/task/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTaskListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/task/create': {
      id: '/_authenticated/settings/task/create'
      path: '/settings/task/create'
      fullPath: '/settings/task/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTaskCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/task/$id': {
      id: '/_authenticated/settings/task/$id'
      path: '/settings/task/$id'
      fullPath: '/settings/task/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsTaskChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/subscription/success': {
      id: '/_authenticated/settings/subscription/success'
      path: '/settings/subscription/success'
      fullPath: '/settings/subscription/success'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSubscriptionSuccessRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/subscription/peach': {
      id: '/_authenticated/settings/subscription/peach'
      path: '/settings/subscription/peach'
      fullPath: '/settings/subscription/peach'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSubscriptionPeachRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/subscription/manage': {
      id: '/_authenticated/settings/subscription/manage'
      path: '/settings/subscription/manage'
      fullPath: '/settings/subscription/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSubscriptionManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/subscription/cancel': {
      id: '/_authenticated/settings/subscription/cancel'
      path: '/settings/subscription/cancel'
      fullPath: '/settings/subscription/cancel'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSubscriptionCancelRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/store/list': {
      id: '/_authenticated/settings/store/list'
      path: '/settings/store/list'
      fullPath: '/settings/store/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsStoreListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/store/create': {
      id: '/_authenticated/settings/store/create'
      path: '/settings/store/create'
      fullPath: '/settings/store/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsStoreCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/store/$id': {
      id: '/_authenticated/settings/store/$id'
      path: '/settings/store/$id'
      fullPath: '/settings/store/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsStoreChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/signaturetemplate/list': {
      id: '/_authenticated/settings/signaturetemplate/list'
      path: '/settings/signaturetemplate/list'
      fullPath: '/settings/signaturetemplate/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSignaturetemplateListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/signaturetemplate/create': {
      id: '/_authenticated/settings/signaturetemplate/create'
      path: '/settings/signaturetemplate/create'
      fullPath: '/settings/signaturetemplate/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSignaturetemplateCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/signaturetemplate/$id': {
      id: '/_authenticated/settings/signaturetemplate/$id'
      path: '/settings/signaturetemplate/$id'
      fullPath: '/settings/signaturetemplate/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/quote/manage': {
      id: '/_authenticated/settings/quote/manage'
      path: '/settings/quote/manage'
      fullPath: '/settings/quote/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsQuoteManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/query/manage': {
      id: '/_authenticated/settings/query/manage'
      path: '/settings/query/manage'
      fullPath: '/settings/query/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsQueryManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/purchase/manage': {
      id: '/_authenticated/settings/purchase/manage'
      path: '/settings/purchase/manage'
      fullPath: '/settings/purchase/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsPurchaseManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/project/manage': {
      id: '/_authenticated/settings/project/manage'
      path: '/settings/project/manage'
      fullPath: '/settings/project/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsProjectManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/payment/payfast': {
      id: '/_authenticated/settings/payment/payfast'
      path: '/settings/payment/payfast'
      fullPath: '/settings/payment/payfast'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsPaymentPayfastRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/option/list': {
      id: '/_authenticated/settings/option/list'
      path: '/settings/option/list'
      fullPath: '/settings/option/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsOptionListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/option/create': {
      id: '/_authenticated/settings/option/create'
      path: '/settings/option/create'
      fullPath: '/settings/option/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsOptionCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/option/$id': {
      id: '/_authenticated/settings/option/$id'
      path: '/settings/option/$id'
      fullPath: '/settings/option/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsOptionChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/job/manage': {
      id: '/_authenticated/settings/job/manage'
      path: '/settings/job/manage'
      fullPath: '/settings/job/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsJobManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/invoice/manage': {
      id: '/_authenticated/settings/invoice/manage'
      path: '/settings/invoice/manage'
      fullPath: '/settings/invoice/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsInvoiceManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/inventory/manage': {
      id: '/_authenticated/settings/inventory/manage'
      path: '/settings/inventory/manage'
      fullPath: '/settings/inventory/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsInventoryManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/integration/oauthxero': {
      id: '/_authenticated/settings/integration/oauthxero'
      path: '/settings/integration/oauthxero'
      fullPath: '/settings/integration/oauthxero'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthxeroRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/integration/oauthsageone': {
      id: '/_authenticated/settings/integration/oauthsageone'
      path: '/settings/integration/oauthsageone'
      fullPath: '/settings/integration/oauthsageone'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthsageoneRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/integration/oauthqbo': {
      id: '/_authenticated/settings/integration/oauthqbo'
      path: '/settings/integration/oauthqbo'
      fullPath: '/settings/integration/oauthqbo'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthqboRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/integration/manage': {
      id: '/_authenticated/settings/integration/manage'
      path: '/settings/integration/manage'
      fullPath: '/settings/integration/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsIntegrationManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/import/smart': {
      id: '/_authenticated/settings/import/smart'
      path: '/settings/import/smart'
      fullPath: '/settings/import/smart'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsImportSmartImportRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/import/list': {
      id: '/_authenticated/settings/import/list'
      path: '/settings/import/list'
      fullPath: '/settings/import/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsImportListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/import/create': {
      id: '/_authenticated/settings/import/create'
      path: '/settings/import/create'
      fullPath: '/settings/import/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsImportCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/form/list': {
      id: '/_authenticated/settings/form/list'
      path: '/settings/form/list'
      fullPath: '/settings/form/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsFormListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/form/create': {
      id: '/_authenticated/settings/form/create'
      path: '/settings/form/create'
      fullPath: '/settings/form/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsFormCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/form/$id': {
      id: '/_authenticated/settings/form/$id'
      path: '/settings/form/$id'
      fullPath: '/settings/form/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsFormChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/employee/list': {
      id: '/_authenticated/settings/employee/list'
      path: '/settings/employee/list'
      fullPath: '/settings/employee/list'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsEmployeeListRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/employee/create': {
      id: '/_authenticated/settings/employee/create'
      path: '/settings/employee/create'
      fullPath: '/settings/employee/create'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsEmployeeCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/employee/$id': {
      id: '/_authenticated/settings/employee/$id'
      path: '/settings/employee/$id'
      fullPath: '/settings/employee/$id'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsEmployeeChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/document/manage': {
      id: '/_authenticated/settings/document/manage'
      path: '/settings/document/manage'
      fullPath: '/settings/document/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsDocumentManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/customer/manage': {
      id: '/_authenticated/settings/customer/manage'
      path: '/settings/customer/manage'
      fullPath: '/settings/customer/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsCustomerManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/company/manage': {
      id: '/_authenticated/settings/company/manage'
      path: '/settings/company/manage'
      fullPath: '/settings/company/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsCompanyManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/asset/manage': {
      id: '/_authenticated/settings/asset/manage'
      path: '/settings/asset/manage'
      fullPath: '/settings/asset/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsAssetManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/settings/api/manage': {
      id: '/_authenticated/settings/api/manage'
      path: '/settings/api/manage'
      fullPath: '/settings/api/manage'
      preLoaderRoute: typeof DotDotDotDotPagesSettingsApiManageRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/quote/view/$id': {
      id: '/_authenticated/quote/view/$id'
      path: '/quote/view/$id'
      fullPath: '/quote/view/$id'
      preLoaderRoute: typeof DotDotDotDotPagesQuoteViewChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/message/bulk/create': {
      id: '/_authenticated/message/bulk/create'
      path: '/message/bulk/create'
      fullPath: '/message/bulk/create'
      preLoaderRoute: typeof DotDotDotDotPagesMessageBulkCreateRouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/message/bulk/$id': {
      id: '/_authenticated/message/bulk/$id'
      path: '/message/bulk/$id'
      fullPath: '/message/bulk/$id'
      preLoaderRoute: typeof DotDotDotDotPagesMessageBulkChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/_authenticated/invoice/view/$id': {
      id: '/_authenticated/invoice/view/$id'
      path: '/invoice/view/$id'
      fullPath: '/invoice/view/$id'
      preLoaderRoute: typeof DotDotDotDotPagesInvoiceViewChar91idChar93RouteImport
      parentRoute: typeof authenticatedRoute
    }
    '/webform/$origin/$key/$api/$css': {
      id: '/webform/$origin/$key/$api/$css'
      path: '/webform/$origin/$key/$api/$css'
      fullPath: '/webform/$origin/$key/$api/$css'
      preLoaderRoute: typeof DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface authenticatedRouteChildren {
  DotDotDotDotPagesAdminRoute: typeof DotDotDotDotPagesAdminRoute
  DotDotDotDotPagesIndexRoute: typeof DotDotDotDotPagesIndexRoute
  DotDotDotDotPagesAppointmentIndexRoute: typeof DotDotDotDotPagesAppointmentIndexRoute
  DotDotDotDotPagesFeedbearIndexRoute: typeof DotDotDotDotPagesFeedbearIndexRoute
  appointmentListRedirectRoute: typeof appointmentListRedirectRoute
  DotDotDotDotPagesAppointmentSchedulerRoute: typeof DotDotDotDotPagesAppointmentSchedulerRoute
  DotDotDotDotPagesAssetChar91idChar93Route: typeof DotDotDotDotPagesAssetChar91idChar93Route
  DotDotDotDotPagesAssetCreateRoute: typeof DotDotDotDotPagesAssetCreateRoute
  DotDotDotDotPagesAssetListRoute: typeof DotDotDotDotPagesAssetListRoute
  DotDotDotDotPagesAttachmentListRoute: typeof DotDotDotDotPagesAttachmentListRoute
  DotDotDotDotPagesBundleChar91idChar93Route: typeof DotDotDotDotPagesBundleChar91idChar93Route
  DotDotDotDotPagesBundleCreateRoute: typeof DotDotDotDotPagesBundleCreateRoute
  DotDotDotDotPagesCustomerChar91idChar93Route: typeof DotDotDotDotPagesCustomerChar91idChar93Route
  DotDotDotDotPagesCustomerCreateRoute: typeof DotDotDotDotPagesCustomerCreateRoute
  DotDotDotDotPagesCustomerListRoute: typeof DotDotDotDotPagesCustomerListRoute
  DotDotDotDotPagesInventoryCategoryChar91idChar93Route: typeof DotDotDotDotPagesInventoryCategoryChar91idChar93Route
  DotDotDotDotPagesInventoryCategoryCreateRoute: typeof DotDotDotDotPagesInventoryCategoryCreateRoute
  DotDotDotDotPagesInventoryCategoryListRoute: typeof DotDotDotDotPagesInventoryCategoryListRoute
  DotDotDotDotPagesInventorySubcategoryChar91idChar93Route: typeof DotDotDotDotPagesInventorySubcategoryChar91idChar93Route
  DotDotDotDotPagesInventorySubcategoryCreateRoute: typeof DotDotDotDotPagesInventorySubcategoryCreateRoute
  DotDotDotDotPagesInventorySubcategoryListRoute: typeof DotDotDotDotPagesInventorySubcategoryListRoute
  DotDotDotDotPagesInventoryChar91idChar93Route: typeof DotDotDotDotPagesInventoryChar91idChar93Route
  DotDotDotDotPagesInventoryCreateRoute: typeof DotDotDotDotPagesInventoryCreateRoute
  DotDotDotDotPagesInventoryListRoute: typeof DotDotDotDotPagesInventoryListRoute
  DotDotDotDotPagesInvoiceChar91idChar93Route: typeof DotDotDotDotPagesInvoiceChar91idChar93Route
  DotDotDotDotPagesInvoiceCreateRoute: typeof DotDotDotDotPagesInvoiceCreateRoute
  DotDotDotDotPagesInvoiceListRoute: typeof DotDotDotDotPagesInvoiceListRoute
  DotDotDotDotPagesJobScheduleChar91idChar93Route: typeof DotDotDotDotPagesJobScheduleChar91idChar93Route
  DotDotDotDotPagesJobScheduleCreateRoute: typeof DotDotDotDotPagesJobScheduleCreateRoute
  DotDotDotDotPagesJobScheduleListRoute: typeof DotDotDotDotPagesJobScheduleListRoute
  DotDotDotDotPagesJobChar91idChar93Route: typeof DotDotDotDotPagesJobChar91idChar93Route
  DotDotDotDotPagesJobCreateRoute: typeof DotDotDotDotPagesJobCreateRoute
  DotDotDotDotPagesJobJobMapRoute: typeof DotDotDotDotPagesJobJobMapRoute
  DotDotDotDotPagesJobListRoute: typeof DotDotDotDotPagesJobListRoute
  DotDotDotDotPagesMessageListRoute: typeof DotDotDotDotPagesMessageListRoute
  DotDotDotDotPagesNewCommunicationChar91idChar93Route: typeof DotDotDotDotPagesNewCommunicationChar91idChar93Route
  DotDotDotDotPagesProjectChar91idChar93Route: typeof DotDotDotDotPagesProjectChar91idChar93Route
  DotDotDotDotPagesProjectCreateRoute: typeof DotDotDotDotPagesProjectCreateRoute
  DotDotDotDotPagesProjectListRoute: typeof DotDotDotDotPagesProjectListRoute
  DotDotDotDotPagesPurchaseChar91idChar93Route: typeof DotDotDotDotPagesPurchaseChar91idChar93Route
  DotDotDotDotPagesPurchaseCreateRoute: typeof DotDotDotDotPagesPurchaseCreateRoute
  DotDotDotDotPagesPurchaseListRoute: typeof DotDotDotDotPagesPurchaseListRoute
  DotDotDotDotPagesQueryChar91idChar93Route: typeof DotDotDotDotPagesQueryChar91idChar93Route
  DotDotDotDotPagesQueryCreateRoute: typeof DotDotDotDotPagesQueryCreateRoute
  DotDotDotDotPagesQueryListRoute: typeof DotDotDotDotPagesQueryListRoute
  DotDotDotDotPagesQuoteChar91idChar93Route: typeof DotDotDotDotPagesQuoteChar91idChar93Route
  DotDotDotDotPagesQuoteCreateRoute: typeof DotDotDotDotPagesQuoteCreateRoute
  DotDotDotDotPagesQuoteListRoute: typeof DotDotDotDotPagesQuoteListRoute
  DotDotDotDotPagesReportListRoute: typeof DotDotDotDotPagesReportListRoute
  DotDotDotDotPagesSettingsChangePasswordRoute: typeof DotDotDotDotPagesSettingsChangePasswordRoute
  DotDotDotDotPagesSettingsJobStatusRoute: typeof DotDotDotDotPagesSettingsJobStatusRoute
  DotDotDotDotPagesSettingsRoleSettingsRoute: typeof DotDotDotDotPagesSettingsRoleSettingsRoute
  DotDotDotDotPagesStockTakeCreateRoute: typeof DotDotDotDotPagesStockTakeCreateRoute
  DotDotDotDotPagesStockTakeListRoute: typeof DotDotDotDotPagesStockTakeListRoute
  DotDotDotDotPagesStocktransactionChar91idChar93Route: typeof DotDotDotDotPagesStocktransactionChar91idChar93Route
  DotDotDotDotPagesStocktransactionCreateRoute: typeof DotDotDotDotPagesStocktransactionCreateRoute
  DotDotDotDotPagesStocktransactionListRoute: typeof DotDotDotDotPagesStocktransactionListRoute
  DotDotDotDotPagesSupplierChar91idChar93Route: typeof DotDotDotDotPagesSupplierChar91idChar93Route
  DotDotDotDotPagesSupplierCreateRoute: typeof DotDotDotDotPagesSupplierCreateRoute
  DotDotDotDotPagesSupplierListRoute: typeof DotDotDotDotPagesSupplierListRoute
  DotDotDotDotPagesVanCreateRoute: typeof DotDotDotDotPagesVanCreateRoute
  DotDotDotDotPagesVanListRoute: typeof DotDotDotDotPagesVanListRoute
  DotDotDotDotPagesStockTakeChar91idChar93IndexRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93IndexRoute
  DotDotDotDotPagesVanChar91idChar93IndexRoute: typeof DotDotDotDotPagesVanChar91idChar93IndexRoute
  DotDotDotDotPagesInvoiceViewChar91idChar93Route: typeof DotDotDotDotPagesInvoiceViewChar91idChar93Route
  DotDotDotDotPagesMessageBulkChar91idChar93Route: typeof DotDotDotDotPagesMessageBulkChar91idChar93Route
  DotDotDotDotPagesMessageBulkCreateRoute: typeof DotDotDotDotPagesMessageBulkCreateRoute
  DotDotDotDotPagesQuoteViewChar91idChar93Route: typeof DotDotDotDotPagesQuoteViewChar91idChar93Route
  DotDotDotDotPagesSettingsApiManageRoute: typeof DotDotDotDotPagesSettingsApiManageRoute
  DotDotDotDotPagesSettingsAssetManageRoute: typeof DotDotDotDotPagesSettingsAssetManageRoute
  DotDotDotDotPagesSettingsCompanyManageRoute: typeof DotDotDotDotPagesSettingsCompanyManageRoute
  DotDotDotDotPagesSettingsCustomerManageRoute: typeof DotDotDotDotPagesSettingsCustomerManageRoute
  DotDotDotDotPagesSettingsDocumentManageRoute: typeof DotDotDotDotPagesSettingsDocumentManageRoute
  DotDotDotDotPagesSettingsEmployeeChar91idChar93Route: typeof DotDotDotDotPagesSettingsEmployeeChar91idChar93Route
  DotDotDotDotPagesSettingsEmployeeCreateRoute: typeof DotDotDotDotPagesSettingsEmployeeCreateRoute
  DotDotDotDotPagesSettingsEmployeeListRoute: typeof DotDotDotDotPagesSettingsEmployeeListRoute
  DotDotDotDotPagesSettingsFormChar91idChar93Route: typeof DotDotDotDotPagesSettingsFormChar91idChar93Route
  DotDotDotDotPagesSettingsFormCreateRoute: typeof DotDotDotDotPagesSettingsFormCreateRoute
  DotDotDotDotPagesSettingsFormListRoute: typeof DotDotDotDotPagesSettingsFormListRoute
  DotDotDotDotPagesSettingsImportCreateRoute: typeof DotDotDotDotPagesSettingsImportCreateRoute
  DotDotDotDotPagesSettingsImportListRoute: typeof DotDotDotDotPagesSettingsImportListRoute
  DotDotDotDotPagesSettingsImportSmartImportRoute: typeof DotDotDotDotPagesSettingsImportSmartImportRoute
  DotDotDotDotPagesSettingsIntegrationManageRoute: typeof DotDotDotDotPagesSettingsIntegrationManageRoute
  DotDotDotDotPagesSettingsIntegrationOauthqboRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthqboRoute
  DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute
  DotDotDotDotPagesSettingsIntegrationOauthxeroRoute: typeof DotDotDotDotPagesSettingsIntegrationOauthxeroRoute
  DotDotDotDotPagesSettingsInventoryManageRoute: typeof DotDotDotDotPagesSettingsInventoryManageRoute
  DotDotDotDotPagesSettingsInvoiceManageRoute: typeof DotDotDotDotPagesSettingsInvoiceManageRoute
  DotDotDotDotPagesSettingsJobManageRoute: typeof DotDotDotDotPagesSettingsJobManageRoute
  DotDotDotDotPagesSettingsOptionChar91idChar93Route: typeof DotDotDotDotPagesSettingsOptionChar91idChar93Route
  DotDotDotDotPagesSettingsOptionCreateRoute: typeof DotDotDotDotPagesSettingsOptionCreateRoute
  DotDotDotDotPagesSettingsOptionListRoute: typeof DotDotDotDotPagesSettingsOptionListRoute
  DotDotDotDotPagesSettingsPaymentPayfastRoute: typeof DotDotDotDotPagesSettingsPaymentPayfastRoute
  DotDotDotDotPagesSettingsProjectManageRoute: typeof DotDotDotDotPagesSettingsProjectManageRoute
  DotDotDotDotPagesSettingsPurchaseManageRoute: typeof DotDotDotDotPagesSettingsPurchaseManageRoute
  DotDotDotDotPagesSettingsQueryManageRoute: typeof DotDotDotDotPagesSettingsQueryManageRoute
  DotDotDotDotPagesSettingsQuoteManageRoute: typeof DotDotDotDotPagesSettingsQuoteManageRoute
  DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route: typeof DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route
  DotDotDotDotPagesSettingsSignaturetemplateCreateRoute: typeof DotDotDotDotPagesSettingsSignaturetemplateCreateRoute
  DotDotDotDotPagesSettingsSignaturetemplateListRoute: typeof DotDotDotDotPagesSettingsSignaturetemplateListRoute
  DotDotDotDotPagesSettingsStoreChar91idChar93Route: typeof DotDotDotDotPagesSettingsStoreChar91idChar93Route
  DotDotDotDotPagesSettingsStoreCreateRoute: typeof DotDotDotDotPagesSettingsStoreCreateRoute
  DotDotDotDotPagesSettingsStoreListRoute: typeof DotDotDotDotPagesSettingsStoreListRoute
  DotDotDotDotPagesSettingsSubscriptionCancelRoute: typeof DotDotDotDotPagesSettingsSubscriptionCancelRoute
  DotDotDotDotPagesSettingsSubscriptionManageRoute: typeof DotDotDotDotPagesSettingsSubscriptionManageRoute
  DotDotDotDotPagesSettingsSubscriptionPeachRoute: typeof DotDotDotDotPagesSettingsSubscriptionPeachRoute
  DotDotDotDotPagesSettingsSubscriptionSuccessRoute: typeof DotDotDotDotPagesSettingsSubscriptionSuccessRoute
  DotDotDotDotPagesSettingsTaskChar91idChar93Route: typeof DotDotDotDotPagesSettingsTaskChar91idChar93Route
  DotDotDotDotPagesSettingsTaskCreateRoute: typeof DotDotDotDotPagesSettingsTaskCreateRoute
  DotDotDotDotPagesSettingsTaskListRoute: typeof DotDotDotDotPagesSettingsTaskListRoute
  DotDotDotDotPagesSettingsTemplateChar91idChar93Route: typeof DotDotDotDotPagesSettingsTemplateChar91idChar93Route
  DotDotDotDotPagesSettingsTemplateCreateRoute: typeof DotDotDotDotPagesSettingsTemplateCreateRoute
  DotDotDotDotPagesSettingsTemplateEditRoute: typeof DotDotDotDotPagesSettingsTemplateEditRoute
  DotDotDotDotPagesSettingsTemplateListRoute: typeof DotDotDotDotPagesSettingsTemplateListRoute
  DotDotDotDotPagesSettingsTriggerChar91idChar93Route: typeof DotDotDotDotPagesSettingsTriggerChar91idChar93Route
  DotDotDotDotPagesSettingsTriggerCreateRoute: typeof DotDotDotDotPagesSettingsTriggerCreateRoute
  DotDotDotDotPagesSettingsTriggerListRoute: typeof DotDotDotDotPagesSettingsTriggerListRoute
  DotDotDotDotPagesSettingsWarehouseChar91idChar93Route: typeof DotDotDotDotPagesSettingsWarehouseChar91idChar93Route
  DotDotDotDotPagesSettingsWarehouseCreateRoute: typeof DotDotDotDotPagesSettingsWarehouseCreateRoute
  DotDotDotDotPagesSettingsWarehouseListRoute: typeof DotDotDotDotPagesSettingsWarehouseListRoute
  DotDotDotDotPagesSettingsWebformChar91idChar93Route: typeof DotDotDotDotPagesSettingsWebformChar91idChar93Route
  DotDotDotDotPagesSettingsWebformCreateRoute: typeof DotDotDotDotPagesSettingsWebformCreateRoute
  DotDotDotDotPagesSettingsWebformListRoute: typeof DotDotDotDotPagesSettingsWebformListRoute
  DotDotDotDotPagesStockTakeChar91idChar93CopyRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93CopyRoute
  DotDotDotDotPagesStockTakeChar91idChar93EditRoute: typeof DotDotDotDotPagesStockTakeChar91idChar93EditRoute
  DotDotDotDotPagesStockTakeTemplateChar91idChar93Route: typeof DotDotDotDotPagesStockTakeTemplateChar91idChar93Route
  DotDotDotDotPagesStockTakeTemplateCreateRoute: typeof DotDotDotDotPagesStockTakeTemplateCreateRoute
  DotDotDotDotPagesStocktransactionAdjustmentListRoute: typeof DotDotDotDotPagesStocktransactionAdjustmentListRoute
  DotDotDotDotPagesStocktransactionExternalTransferListRoute: typeof DotDotDotDotPagesStocktransactionExternalTransferListRoute
  DotDotDotDotPagesStocktransactionGrvListRoute: typeof DotDotDotDotPagesStocktransactionGrvListRoute
  DotDotDotDotPagesStocktransactionTransferListRoute: typeof DotDotDotDotPagesStocktransactionTransferListRoute
  DotDotDotDotPagesVanChar91idChar93EditRoute: typeof DotDotDotDotPagesVanChar91idChar93EditRoute
}

const authenticatedRouteChildren: authenticatedRouteChildren = {
  DotDotDotDotPagesAdminRoute: DotDotDotDotPagesAdminRoute,
  DotDotDotDotPagesIndexRoute: DotDotDotDotPagesIndexRoute,
  DotDotDotDotPagesAppointmentIndexRoute:
    DotDotDotDotPagesAppointmentIndexRoute,
  DotDotDotDotPagesFeedbearIndexRoute: DotDotDotDotPagesFeedbearIndexRoute,
  appointmentListRedirectRoute: appointmentListRedirectRoute,
  DotDotDotDotPagesAppointmentSchedulerRoute:
    DotDotDotDotPagesAppointmentSchedulerRoute,
  DotDotDotDotPagesAssetChar91idChar93Route:
    DotDotDotDotPagesAssetChar91idChar93Route,
  DotDotDotDotPagesAssetCreateRoute: DotDotDotDotPagesAssetCreateRoute,
  DotDotDotDotPagesAssetListRoute: DotDotDotDotPagesAssetListRoute,
  DotDotDotDotPagesAttachmentListRoute: DotDotDotDotPagesAttachmentListRoute,
  DotDotDotDotPagesBundleChar91idChar93Route:
    DotDotDotDotPagesBundleChar91idChar93Route,
  DotDotDotDotPagesBundleCreateRoute: DotDotDotDotPagesBundleCreateRoute,
  DotDotDotDotPagesCustomerChar91idChar93Route:
    DotDotDotDotPagesCustomerChar91idChar93Route,
  DotDotDotDotPagesCustomerCreateRoute: DotDotDotDotPagesCustomerCreateRoute,
  DotDotDotDotPagesCustomerListRoute: DotDotDotDotPagesCustomerListRoute,
  DotDotDotDotPagesInventoryCategoryChar91idChar93Route:
    DotDotDotDotPagesInventoryCategoryChar91idChar93Route,
  DotDotDotDotPagesInventoryCategoryCreateRoute:
    DotDotDotDotPagesInventoryCategoryCreateRoute,
  DotDotDotDotPagesInventoryCategoryListRoute:
    DotDotDotDotPagesInventoryCategoryListRoute,
  DotDotDotDotPagesInventorySubcategoryChar91idChar93Route:
    DotDotDotDotPagesInventorySubcategoryChar91idChar93Route,
  DotDotDotDotPagesInventorySubcategoryCreateRoute:
    DotDotDotDotPagesInventorySubcategoryCreateRoute,
  DotDotDotDotPagesInventorySubcategoryListRoute:
    DotDotDotDotPagesInventorySubcategoryListRoute,
  DotDotDotDotPagesInventoryChar91idChar93Route:
    DotDotDotDotPagesInventoryChar91idChar93Route,
  DotDotDotDotPagesInventoryCreateRoute: DotDotDotDotPagesInventoryCreateRoute,
  DotDotDotDotPagesInventoryListRoute: DotDotDotDotPagesInventoryListRoute,
  DotDotDotDotPagesInvoiceChar91idChar93Route:
    DotDotDotDotPagesInvoiceChar91idChar93Route,
  DotDotDotDotPagesInvoiceCreateRoute: DotDotDotDotPagesInvoiceCreateRoute,
  DotDotDotDotPagesInvoiceListRoute: DotDotDotDotPagesInvoiceListRoute,
  DotDotDotDotPagesJobScheduleChar91idChar93Route:
    DotDotDotDotPagesJobScheduleChar91idChar93Route,
  DotDotDotDotPagesJobScheduleCreateRoute:
    DotDotDotDotPagesJobScheduleCreateRoute,
  DotDotDotDotPagesJobScheduleListRoute: DotDotDotDotPagesJobScheduleListRoute,
  DotDotDotDotPagesJobChar91idChar93Route:
    DotDotDotDotPagesJobChar91idChar93Route,
  DotDotDotDotPagesJobCreateRoute: DotDotDotDotPagesJobCreateRoute,
  DotDotDotDotPagesJobJobMapRoute: DotDotDotDotPagesJobJobMapRoute,
  DotDotDotDotPagesJobListRoute: DotDotDotDotPagesJobListRoute,
  DotDotDotDotPagesMessageListRoute: DotDotDotDotPagesMessageListRoute,
  DotDotDotDotPagesNewCommunicationChar91idChar93Route:
    DotDotDotDotPagesNewCommunicationChar91idChar93Route,
  DotDotDotDotPagesProjectChar91idChar93Route:
    DotDotDotDotPagesProjectChar91idChar93Route,
  DotDotDotDotPagesProjectCreateRoute: DotDotDotDotPagesProjectCreateRoute,
  DotDotDotDotPagesProjectListRoute: DotDotDotDotPagesProjectListRoute,
  DotDotDotDotPagesPurchaseChar91idChar93Route:
    DotDotDotDotPagesPurchaseChar91idChar93Route,
  DotDotDotDotPagesPurchaseCreateRoute: DotDotDotDotPagesPurchaseCreateRoute,
  DotDotDotDotPagesPurchaseListRoute: DotDotDotDotPagesPurchaseListRoute,
  DotDotDotDotPagesQueryChar91idChar93Route:
    DotDotDotDotPagesQueryChar91idChar93Route,
  DotDotDotDotPagesQueryCreateRoute: DotDotDotDotPagesQueryCreateRoute,
  DotDotDotDotPagesQueryListRoute: DotDotDotDotPagesQueryListRoute,
  DotDotDotDotPagesQuoteChar91idChar93Route:
    DotDotDotDotPagesQuoteChar91idChar93Route,
  DotDotDotDotPagesQuoteCreateRoute: DotDotDotDotPagesQuoteCreateRoute,
  DotDotDotDotPagesQuoteListRoute: DotDotDotDotPagesQuoteListRoute,
  DotDotDotDotPagesReportListRoute: DotDotDotDotPagesReportListRoute,
  DotDotDotDotPagesSettingsChangePasswordRoute:
    DotDotDotDotPagesSettingsChangePasswordRoute,
  DotDotDotDotPagesSettingsJobStatusRoute:
    DotDotDotDotPagesSettingsJobStatusRoute,
  DotDotDotDotPagesSettingsRoleSettingsRoute:
    DotDotDotDotPagesSettingsRoleSettingsRoute,
  DotDotDotDotPagesStockTakeCreateRoute: DotDotDotDotPagesStockTakeCreateRoute,
  DotDotDotDotPagesStockTakeListRoute: DotDotDotDotPagesStockTakeListRoute,
  DotDotDotDotPagesStocktransactionChar91idChar93Route:
    DotDotDotDotPagesStocktransactionChar91idChar93Route,
  DotDotDotDotPagesStocktransactionCreateRoute:
    DotDotDotDotPagesStocktransactionCreateRoute,
  DotDotDotDotPagesStocktransactionListRoute:
    DotDotDotDotPagesStocktransactionListRoute,
  DotDotDotDotPagesSupplierChar91idChar93Route:
    DotDotDotDotPagesSupplierChar91idChar93Route,
  DotDotDotDotPagesSupplierCreateRoute: DotDotDotDotPagesSupplierCreateRoute,
  DotDotDotDotPagesSupplierListRoute: DotDotDotDotPagesSupplierListRoute,
  DotDotDotDotPagesVanCreateRoute: DotDotDotDotPagesVanCreateRoute,
  DotDotDotDotPagesVanListRoute: DotDotDotDotPagesVanListRoute,
  DotDotDotDotPagesStockTakeChar91idChar93IndexRoute:
    DotDotDotDotPagesStockTakeChar91idChar93IndexRoute,
  DotDotDotDotPagesVanChar91idChar93IndexRoute:
    DotDotDotDotPagesVanChar91idChar93IndexRoute,
  DotDotDotDotPagesInvoiceViewChar91idChar93Route:
    DotDotDotDotPagesInvoiceViewChar91idChar93Route,
  DotDotDotDotPagesMessageBulkChar91idChar93Route:
    DotDotDotDotPagesMessageBulkChar91idChar93Route,
  DotDotDotDotPagesMessageBulkCreateRoute:
    DotDotDotDotPagesMessageBulkCreateRoute,
  DotDotDotDotPagesQuoteViewChar91idChar93Route:
    DotDotDotDotPagesQuoteViewChar91idChar93Route,
  DotDotDotDotPagesSettingsApiManageRoute:
    DotDotDotDotPagesSettingsApiManageRoute,
  DotDotDotDotPagesSettingsAssetManageRoute:
    DotDotDotDotPagesSettingsAssetManageRoute,
  DotDotDotDotPagesSettingsCompanyManageRoute:
    DotDotDotDotPagesSettingsCompanyManageRoute,
  DotDotDotDotPagesSettingsCustomerManageRoute:
    DotDotDotDotPagesSettingsCustomerManageRoute,
  DotDotDotDotPagesSettingsDocumentManageRoute:
    DotDotDotDotPagesSettingsDocumentManageRoute,
  DotDotDotDotPagesSettingsEmployeeChar91idChar93Route:
    DotDotDotDotPagesSettingsEmployeeChar91idChar93Route,
  DotDotDotDotPagesSettingsEmployeeCreateRoute:
    DotDotDotDotPagesSettingsEmployeeCreateRoute,
  DotDotDotDotPagesSettingsEmployeeListRoute:
    DotDotDotDotPagesSettingsEmployeeListRoute,
  DotDotDotDotPagesSettingsFormChar91idChar93Route:
    DotDotDotDotPagesSettingsFormChar91idChar93Route,
  DotDotDotDotPagesSettingsFormCreateRoute:
    DotDotDotDotPagesSettingsFormCreateRoute,
  DotDotDotDotPagesSettingsFormListRoute:
    DotDotDotDotPagesSettingsFormListRoute,
  DotDotDotDotPagesSettingsImportCreateRoute:
    DotDotDotDotPagesSettingsImportCreateRoute,
  DotDotDotDotPagesSettingsImportListRoute:
    DotDotDotDotPagesSettingsImportListRoute,
  DotDotDotDotPagesSettingsImportSmartImportRoute:
    DotDotDotDotPagesSettingsImportSmartImportRoute,
  DotDotDotDotPagesSettingsIntegrationManageRoute:
    DotDotDotDotPagesSettingsIntegrationManageRoute,
  DotDotDotDotPagesSettingsIntegrationOauthqboRoute:
    DotDotDotDotPagesSettingsIntegrationOauthqboRoute,
  DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute:
    DotDotDotDotPagesSettingsIntegrationOauthsageoneRoute,
  DotDotDotDotPagesSettingsIntegrationOauthxeroRoute:
    DotDotDotDotPagesSettingsIntegrationOauthxeroRoute,
  DotDotDotDotPagesSettingsInventoryManageRoute:
    DotDotDotDotPagesSettingsInventoryManageRoute,
  DotDotDotDotPagesSettingsInvoiceManageRoute:
    DotDotDotDotPagesSettingsInvoiceManageRoute,
  DotDotDotDotPagesSettingsJobManageRoute:
    DotDotDotDotPagesSettingsJobManageRoute,
  DotDotDotDotPagesSettingsOptionChar91idChar93Route:
    DotDotDotDotPagesSettingsOptionChar91idChar93Route,
  DotDotDotDotPagesSettingsOptionCreateRoute:
    DotDotDotDotPagesSettingsOptionCreateRoute,
  DotDotDotDotPagesSettingsOptionListRoute:
    DotDotDotDotPagesSettingsOptionListRoute,
  DotDotDotDotPagesSettingsPaymentPayfastRoute:
    DotDotDotDotPagesSettingsPaymentPayfastRoute,
  DotDotDotDotPagesSettingsProjectManageRoute:
    DotDotDotDotPagesSettingsProjectManageRoute,
  DotDotDotDotPagesSettingsPurchaseManageRoute:
    DotDotDotDotPagesSettingsPurchaseManageRoute,
  DotDotDotDotPagesSettingsQueryManageRoute:
    DotDotDotDotPagesSettingsQueryManageRoute,
  DotDotDotDotPagesSettingsQuoteManageRoute:
    DotDotDotDotPagesSettingsQuoteManageRoute,
  DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route:
    DotDotDotDotPagesSettingsSignaturetemplateChar91idChar93Route,
  DotDotDotDotPagesSettingsSignaturetemplateCreateRoute:
    DotDotDotDotPagesSettingsSignaturetemplateCreateRoute,
  DotDotDotDotPagesSettingsSignaturetemplateListRoute:
    DotDotDotDotPagesSettingsSignaturetemplateListRoute,
  DotDotDotDotPagesSettingsStoreChar91idChar93Route:
    DotDotDotDotPagesSettingsStoreChar91idChar93Route,
  DotDotDotDotPagesSettingsStoreCreateRoute:
    DotDotDotDotPagesSettingsStoreCreateRoute,
  DotDotDotDotPagesSettingsStoreListRoute:
    DotDotDotDotPagesSettingsStoreListRoute,
  DotDotDotDotPagesSettingsSubscriptionCancelRoute:
    DotDotDotDotPagesSettingsSubscriptionCancelRoute,
  DotDotDotDotPagesSettingsSubscriptionManageRoute:
    DotDotDotDotPagesSettingsSubscriptionManageRoute,
  DotDotDotDotPagesSettingsSubscriptionPeachRoute:
    DotDotDotDotPagesSettingsSubscriptionPeachRoute,
  DotDotDotDotPagesSettingsSubscriptionSuccessRoute:
    DotDotDotDotPagesSettingsSubscriptionSuccessRoute,
  DotDotDotDotPagesSettingsTaskChar91idChar93Route:
    DotDotDotDotPagesSettingsTaskChar91idChar93Route,
  DotDotDotDotPagesSettingsTaskCreateRoute:
    DotDotDotDotPagesSettingsTaskCreateRoute,
  DotDotDotDotPagesSettingsTaskListRoute:
    DotDotDotDotPagesSettingsTaskListRoute,
  DotDotDotDotPagesSettingsTemplateChar91idChar93Route:
    DotDotDotDotPagesSettingsTemplateChar91idChar93Route,
  DotDotDotDotPagesSettingsTemplateCreateRoute:
    DotDotDotDotPagesSettingsTemplateCreateRoute,
  DotDotDotDotPagesSettingsTemplateEditRoute:
    DotDotDotDotPagesSettingsTemplateEditRoute,
  DotDotDotDotPagesSettingsTemplateListRoute:
    DotDotDotDotPagesSettingsTemplateListRoute,
  DotDotDotDotPagesSettingsTriggerChar91idChar93Route:
    DotDotDotDotPagesSettingsTriggerChar91idChar93Route,
  DotDotDotDotPagesSettingsTriggerCreateRoute:
    DotDotDotDotPagesSettingsTriggerCreateRoute,
  DotDotDotDotPagesSettingsTriggerListRoute:
    DotDotDotDotPagesSettingsTriggerListRoute,
  DotDotDotDotPagesSettingsWarehouseChar91idChar93Route:
    DotDotDotDotPagesSettingsWarehouseChar91idChar93Route,
  DotDotDotDotPagesSettingsWarehouseCreateRoute:
    DotDotDotDotPagesSettingsWarehouseCreateRoute,
  DotDotDotDotPagesSettingsWarehouseListRoute:
    DotDotDotDotPagesSettingsWarehouseListRoute,
  DotDotDotDotPagesSettingsWebformChar91idChar93Route:
    DotDotDotDotPagesSettingsWebformChar91idChar93Route,
  DotDotDotDotPagesSettingsWebformCreateRoute:
    DotDotDotDotPagesSettingsWebformCreateRoute,
  DotDotDotDotPagesSettingsWebformListRoute:
    DotDotDotDotPagesSettingsWebformListRoute,
  DotDotDotDotPagesStockTakeChar91idChar93CopyRoute:
    DotDotDotDotPagesStockTakeChar91idChar93CopyRoute,
  DotDotDotDotPagesStockTakeChar91idChar93EditRoute:
    DotDotDotDotPagesStockTakeChar91idChar93EditRoute,
  DotDotDotDotPagesStockTakeTemplateChar91idChar93Route:
    DotDotDotDotPagesStockTakeTemplateChar91idChar93Route,
  DotDotDotDotPagesStockTakeTemplateCreateRoute:
    DotDotDotDotPagesStockTakeTemplateCreateRoute,
  DotDotDotDotPagesStocktransactionAdjustmentListRoute:
    DotDotDotDotPagesStocktransactionAdjustmentListRoute,
  DotDotDotDotPagesStocktransactionExternalTransferListRoute:
    DotDotDotDotPagesStocktransactionExternalTransferListRoute,
  DotDotDotDotPagesStocktransactionGrvListRoute:
    DotDotDotDotPagesStocktransactionGrvListRoute,
  DotDotDotDotPagesStocktransactionTransferListRoute:
    DotDotDotDotPagesStocktransactionTransferListRoute,
  DotDotDotDotPagesVanChar91idChar93EditRoute:
    DotDotDotDotPagesVanChar91idChar93EditRoute,
}

const authenticatedRouteWithChildren = authenticatedRoute._addFileChildren(
  authenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authenticatedRoute: authenticatedRouteWithChildren,
  DotDotDotDotPagesCompleteInviteRoute: DotDotDotDotPagesCompleteInviteRoute,
  DotDotDotDotPagesCompleteSignupRoute: DotDotDotDotPagesCompleteSignupRoute,
  DotDotDotDotPagesDebitOrderRoute: DotDotDotDotPagesDebitOrderRoute,
  loginRoute: loginRoute,
  DotDotDotDotPagesSignUpIcpRoute: DotDotDotDotPagesSignUpIcpRoute,
  DotDotDotDotPagesVerifyRoute: DotDotDotDotPagesVerifyRoute,
  DotDotDotDotPagesActivateIndexRoute: DotDotDotDotPagesActivateIndexRoute,
  DotDotDotDotPagesCustomerzoneIndexRoute:
    DotDotDotDotPagesCustomerzoneIndexRoute,
  DotDotDotDotPagesResetPasswordIndexRoute:
    DotDotDotDotPagesResetPasswordIndexRoute,
  DotDotDotDotPagesWebformIndexRoute: DotDotDotDotPagesWebformIndexRoute,
  DotDotDotDotPagesCustomerzoneAppointmentlistRoute:
    DotDotDotDotPagesCustomerzoneAppointmentlistRoute,
  DotDotDotDotPagesCustomerzoneInvoicelistRoute:
    DotDotDotDotPagesCustomerzoneInvoicelistRoute,
  DotDotDotDotPagesCustomerzoneJobfeedbackRoute:
    DotDotDotDotPagesCustomerzoneJobfeedbackRoute,
  DotDotDotDotPagesCustomerzoneJoblistRoute:
    DotDotDotDotPagesCustomerzoneJoblistRoute,
  DotDotDotDotPagesCustomerzoneQuotelistRoute:
    DotDotDotDotPagesCustomerzoneQuotelistRoute,
  DotDotDotDotPagesCustomerzoneSageinvoicelistRoute:
    DotDotDotDotPagesCustomerzoneSageinvoicelistRoute,
  DotDotDotDotPagesCustomerzoneSignatureRoute:
    DotDotDotDotPagesCustomerzoneSignatureRoute,
  DotDotDotDotPagesCustomerzoneViewappointmentRoute:
    DotDotDotDotPagesCustomerzoneViewappointmentRoute,
  DotDotDotDotPagesCustomerzoneViewinvoiceRoute:
    DotDotDotDotPagesCustomerzoneViewinvoiceRoute,
  DotDotDotDotPagesCustomerzoneViewjobRoute:
    DotDotDotDotPagesCustomerzoneViewjobRoute,
  DotDotDotDotPagesCustomerzoneViewquoteRoute:
    DotDotDotDotPagesCustomerzoneViewquoteRoute,
  DotDotDotDotPagesIChar91tokenChar93Route:
    DotDotDotDotPagesIChar91tokenChar93Route,
  DotDotDotDotPagesTenantzoneSignatureRoute:
    DotDotDotDotPagesTenantzoneSignatureRoute,
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute:
    DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93IndexRoute,
  DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute:
    DotDotDotDotPagesWebformChar91originChar93Char91keyChar93Char91apiChar93Char91cssChar93IndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
